<template>
    <div>
    
        <div v-if="state == '1'">
            <div class="flex flex-center w-full relative">
              <div class="blockInfo">
                  <hr>
                  <figure class="active">
                    <div class="StepNumber">
                      1
                    </div>
                    <figcaption class="stepTextDuplication">{{ $t('text.step1Duplication') }}</figcaption>
                  </figure>

                

                  <figure>
                    <div class="StepNumber">
                      2
                    </div>
                    <figcaption>{{ $t('text.step3Duplication') }}</figcaption>
                  </figure>
              </div>
            </div>
            <ba-search-card legend="Recherche" id="recherche-card">
              <form @submit.prevent="handleFilterResults">
                <div class="cols">
                  <div class="col-4">
                    <ba-select label="Type de pièce" :allow-empty="true" :empty-label="'Moteur & Boîte'" v-model="document_type">
                      <option :value="type.id" v-for="(type, index) in types" :key="`type_${index}`">{{ type.name }}</option>
                    </ba-select>
                  </div>
                  <div class="col-4"><ba-input type="text" label="Marque" v-model="brand"></ba-input></div>
                  <div class="col-4"><ba-input type="text" label="Modèle" v-model="version"></ba-input></div>
                  <div class="col-4">
                    <ba-select label="Energie" :allow-empty="true" :empty-label="'Tous'" v-model="energy">
                      <option v-for="(energy, index) in energies" :value="energy.name" :key="index">{{ energy.name }}</option>
                    </ba-select>
                  </div>

                  <div class="col-4">
                    <ba-select label="Etat" :allow-empty="true" :empty-label="'Tous'" v-model="status_document">
                      <option :value="row.id" v-for="(row, index) in status" :key="'status-'+index">{{ row.label }}</option>
                    </ba-select>
                  </div>
                  <div class="col-4"><ba-input type="text" label="Type moteur" v-model="motor_type"></ba-input></div>
                  <div class="col-4"><ba-input type="text" label="Type boîte" v-model="gearbox_type"></ba-input></div>
                  <div class="col-4"><ba-input type="text" label="Type Mine / Cnit" v-model="cnit"></ba-input></div>

                  <div class="col-4"><ba-input type="text" label="Ktype" v-model="ktype"></ba-input></div>
                  <div class="col-4"><ba-input type="text" label="Identifiant fiche article" v-model="document_id"></ba-input></div>
                  <div class="col-4">
                    <ba-select label="Type Mine / Cnit en attente" :allow-empty="true" :empty-label="'Tous'" v-model="cnit_mine_status">
                      <option v-for="(status, idx) in cnitMineStatus" :value="status.id" :key="`status-cnit-mine-${idx}`">{{ status.label }}</option>
                    </ba-select>
                  </div>
                  <div class="search-buttons-ctn">
                    <div class="buttons-container flex flex-end">
                      <div class="tooltip-container">
                          <span class="filter-link" @click="handleResetFilter"><ab-icon class="refresh" icon="refresh"></ab-icon></span>
                          <div class="tooltip">
                            {{ $t('action.resetFilter') }}
                          </div>
                      </div>
                      <ba-button class="primary" :disabled="filterOnGoing">{{ $t('action.search') }}</ba-button>
                    </div>
                  </div>
                </div>
              </form>
            </ba-search-card>

            <!--nouveau champs de recherche -->
            <ba-search-card legend="Recherche" id="recherche-card-2">
              <form @submit.prevent="handleFilterResults2">
                <div class="cols">
                  <div class="col-4">
                    <ba-select label="Type de pièce" v-model="document_type2">
                      <option :value="type.id" v-for="(type, index) in types" :key="`type_${index}`">{{ type.name }}</option>
                    </ba-select>
                  </div>
                  <div class="col-4"><ba-input type="text" label="Marque" v-model="brand2" class="input" @input="handleSearchMarque()"></ba-input>
					<div v-if="(selectedBrand != null)" style="position: absolute;margin-top: -21px;margin-left: calc(25% - 65px);cursor: pointer;" @click="deleteMarque()">X</div>
              
					<div v-if="(brand2.length > 0) && (selectedBrand == null)" class="dropdown-part" style="width:25%;margin-top:5px;">
                        <ul v-if="listFilterBrand.length" class="dropdown-part-u">
                            <li v-for="(item, index) in listFilterBrand"
                                :key="index"
                                class="dropdown-part-li"
                                @click="selectBrand(item)">
                                        {{ item.name }}
                            </li>
                        </ul>
                                
                    </div>
				</div>

				  <div class="col-4"><ba-input type="text" :label="document_type2 == 2 ? 'Type boîte' : 'Type moteur'" v-model="motor_gearbox_type2" class="input"></ba-input></div>

				  <div class="col-4"><ba-input type="text" label="Identifiant fiche article" v-model="document_id2" class="input"></ba-input></div>

				  <div class="col-4">
                      <div style="display:flex">
                        <div style="margin-top:3px;margin-right:5px;">Fiche Exclue :</div>
                        <ba-checkbox v-model="faExclue"></ba-checkbox>
                      </div>
                      </div>
                 
                  <div class="search-buttons-ctn">
                    <div class="buttons-container flex flex-end">
                      <div class="tooltip-container">
                          <span class="filter-link" @click="handleResetFilter2"><ab-icon class="refresh" icon="refresh"></ab-icon></span>
                          <div class="tooltip">
                            {{ $t('action.resetFilter') }}
                          </div>
                      </div>
                      <ba-button class="primary" :disabled="(brand2.length == 0 && motor_gearbox_type2.length == 0 && document_id2.length == 0)">{{ $t('action.search') }}</ba-button>
                    </div>
                  </div>
                </div>
              </form>
            </ba-search-card>

            <div class="document-button buttons-container flex flex-space">
        <div><span v-if="documentsCount && documentsCount != counter">{{ documentsCount }} sur </span>{{ counter }} {{ $t('text.documents') }}</div>
      
      </div>

            <div class="loading" v-if="loading">
              <mo-loader :loading="loading"></mo-loader>
            </div>
            <ba-table v-if="documents.length && !loading">
              <template slot="colgroup">
                <col>
                <col class="brand">
                <col>
                <col>
                <col>
                <col>
                <col>
                <col>
                <col>
                <col>
				<col>
                <col>
                <col>
              </template>
              <template slot="body">
                <tr v-for="(document, index) in documents" :key="index">
                  <td><img class="img-fit" :src="handleGetBrandImage(document.aaa_brand)" @error='defaultImage' /></td>
                  <td class="brand-data">{{ document.aaa_brand }} {{ document.aaa_model }}<span class="subelement">{{ document.aaa_energy }} - {{ document.tecdoc_date_min | dateYear }}</span><span class="subelement">{{ $t('text.id') }} {{ document.doc_id || document.id }}</span></td>
                  <td>
                    <ul class="motor-gearbox">
                      <li v-for="motor in getTypeAdaptability(document.motor_type)">
                        {{ motor }}
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="motor-gearbox">
                      <li v-for="motor in getTypeAdaptability(document.motor_adapt)">
                        {{ motor }}
                      </li>
                    </ul>
                  </td>
                  <td class="limiteObservation"> <div>{{ document.motor_observation }}</div></td>
                  <td>
                    <ul class="motor-gearbox">
                      <li v-for="gearbox in getTypeAdaptability(document.gearbox_type)">
                        {{ gearbox }}
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="motor-gearbox">
                      <li v-for="gearbox in getTypeAdaptability(document.gearbox_adapt)">
                        {{ gearbox }}
                      </li>
                    </ul>
                  </td>
                  <td class="limiteObservation"> <div>{{ document.gearbox_observation }}</div>
				  </td>
				  <td > <div>{{ document.nbImg }}</div>
				  </td>
				  <td > <div>{{ document.nbDoc }}</div>
				  </td>
                    <div @click="selectFA(document)" class="buttons-container flex flex-end" style="padding: 15px;" >
                        <ba-button class="primary" @click="selectFA(document)" >{{ $t('action.select') }}</ba-button>
                    </div>
                </tr>
              </template>
              <template slot="head">
                <tr>
                  <th :class="[col.class, col.sortable ? 'sortable': '']" v-for="(col, index) in cols" :key="index" @click="sortby(index)">
                    <span>{{ col.label }}<ab-icon :icon="ordercol(index)" v-if="col.sortable && ordercol(index)"></ab-icon></span>
                  </th>
                </tr>
              </template>
            </ba-table>
            <div v-if="!documents.length && !loading">
              <p class="no-data">{{ $t('text.noDocumentsAvailable') }}</p>
            </div>
              <footer class="mt12">
            <paginate
              :pageCount="pageCount(documents)"
              prev-class="prev"
              next-class="next"
              prev-text=" < "
              next-text=" > "
              v-model="currentPage"
              v-if="documents.length && !loading"
              :containerClass="'mo-pagination'">
            </paginate>
          </footer>

        
        </div>
         <div v-if="state == '2'">
          <div class="flex justify-center w-full relative">
             <div class="blockInfo">
               <div class="divPrev">
                  <div class="tooltip-container">
                    <ba-button  class="no-button" @click.native="previousAction">
                      <ab-icon class="prev" icon="prev" iconset="documentduplication"></ab-icon>
                    </ba-button>
                    <div class="tooltip">
                        {{ $t('action.previous') }}
                    </div>
                  </div>
                </div>
               <!-- <ba-button class="primary" @click.native="cancelAction">{{ $t('action.cancel') }}</ba-button>-->
                <hr>
                <figure>
                  <div class="StepNumber">
                    1
                  </div>
                  <figcaption class="stepTextDuplication">{{ $t('text.step1Duplication') }}</figcaption>
                </figure>

              

                <figure>
                  <div class="StepNumber">
                    2
                  </div>
                  <figcaption>{{ $t('text.step3Duplication') }}</figcaption>
                </figure>
                <div class="divPrev2">
                  <div class="tooltip-container">
                    <ba-button  class="no-button" @click.native="nextAction">
                      <ab-icon class="next" icon="next" iconset="documentduplication"></ab-icon>
                    </ba-button>
                    <div class="tooltip">
                        {{ $t('action.next') }}
                    </div>
                  </div>
                </div>
            </div>
          </div>
            <ba-search-card legend="Informations">
                <div style="display:flex;margin-left:40px;">
                <img class="img-fit" :src="handleGetBrandImage(selectedFA.aaa_brand)" @error='defaultImage' />
                <div style="margin-left:20px;display: grid;">{{ selectedFA.aaa_brand }} {{ selectedFA.aaa_model }}<span class="subelement">{{ selectedFA.aaa_energy }} - {{ selectedFA.tecdoc_date_min | dateYear }}</span><span class="subelement">{{ $t('text.idFA') }} {{ selectedFA.doc_id || selectedFA.id }}</span></div>
                </div>
                
            <div class="cards-container flex-stretch flex-space" style="margin:20px;justify-content: center;">
              <ba-card class="observation-card" style="width:45%;margin-right:20px;">
                <template slot="header">
                  <span>{{ $t('sectionTitle.motorOrigin') }}</span>
                </template>
                <template>
                  <div class="container">
                  <div style="display:flex;">
                    <ba-checkbox v-model="motor_type_check" :value="motor_type_check"></ba-checkbox>
                    <ba-input type="text" style="width:100%;"  label="Type moteur" v-model="selectedFA.motor_type"></ba-input>
                  </div>
                  <div style="display:flex;">
                    <ba-checkbox v-model="motor_adapt_check" :value="motor_adapt_check"></ba-checkbox>
                    <ba-input type="text" style="width:100%;"  label="Adaptabilité moteur" v-model="selectedFA.motor_adapt"></ba-input>
                  </div>
                    <div style="display:flex;">
                        <ba-checkbox v-model="motor_observation_check" :value="motor_observation_check"></ba-checkbox>
                        <ba-textarea-perso style="width:100%;"  class="observation texteAreaFA" styletextarea="height:200px;"   label="Observation" v-model="selectedFA.motor_observation"></ba-textarea-perso>
                    </div>
                      
                      <div class="cnit-list">
                        <div>
                            <div style="margin-top: 10px;margin-left: 40px;margin-bottom: 5px;font-size: 0.79rem;">
                              Images
                            </div>
							<div>
							  <div v-for="img in img_motor" style="display:flex;">
								<ba-checkbox v-model="img.selected" :value="img.selected"></ba-checkbox>
								<div >{{img.label }}</div>
								
							  </div>
							</div>
						</div>
                      </div>
					  
					  <div class="cnit-list">
                        <div>
                            <div style="margin-top: 10px;margin-left: 40px;margin-bottom: 5px;font-size: 0.79rem;">
                              Documents
                            </div>
							<div>
							  <div v-for="doc in doc_motor" style="display:flex;">
								<ba-checkbox v-model="doc.selected" :value="doc.selected"></ba-checkbox>
								<div >{{doc.label }}</div>
								
							  </div>
							</div>
						</div>
                      </div>
					  
                  </div>
                </template>
              </ba-card>
              <ba-card class="observation-card" style="width:45%;">
                <template slot="header">
                  <span>{{ $t('sectionTitle.gearboxOrigin') }}</span>
                </template>
                <template>
                  <div class="container">
                    <div style="display:flex;">
                        <ba-checkbox v-model="gearbox_type_check" :value="gearbox_type_check"></ba-checkbox>
                        <ba-input type="text" style="width:100%;"  label="Type boîte" v-model="selectedFA.gearbox_type"></ba-input>
                    </div>
                    <div style="display:flex;">
                        <ba-checkbox v-model="gearbox_adapt_check" :value="gearbox_adapt_check"></ba-checkbox>
                        <ba-input type="text" style="width:100%;"  label="Adaptabilité boîte" v-model="selectedFA.gearbox_adapt"></ba-input>
                    </div>
                    <div style="display:flex;">
                        <ba-checkbox v-model="gearbox_observation_check" :value="gearbox_observation_check"></ba-checkbox>
                        <ba-textarea-perso style="width:100%;" class="observation texteAreaFA" styletextarea="height:200px;" label="Observation" v-model="selectedFA.gearbox_observation"></ba-textarea-perso>
                    </div>
                      <div class="cnit-list">
                        <div>
                            <div style="margin-top: 10px;margin-left: 40px;margin-bottom: 5px;font-size: 0.79rem;">
                              Images
                            </div>
                        <div>
                          <div v-for="img in img_gearbox" style="display:flex;">
                               <ba-checkbox v-model="img.selected" :value="img.selected"></ba-checkbox>
                            <div >{{img.label }}</div>
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </ba-card>
          </div>
        </ba-search-card>
             
             
        </div>
        <div
          v-if="state == '3'"
          class="col-separator"
        >
          <div class="flex justify-center w-full relative">
              <div class="blockInfo">
                  
                  <div class="divPrev">
                    <div class="tooltip-container">
                      <ba-button  class="no-button" @click.native="previousActionStep2">
                        <ab-icon class="prev" icon="prev" iconset="documentduplication"></ab-icon>
                      </ba-button>
                      <div class="tooltip">
                          {{ $t('action.previous') }}
                      </div>
                    </div>
                  </div>
                    <hr>
                    <figure>
                      <div class="StepNumber">
                        1
                      </div>
                      <figcaption class="stepTextDuplication">{{ $t('text.step1Duplication') }}</figcaption>
                    </figure>

      

                    <figure class="active">
                      <div class="StepNumber">
                        2
                      </div>
                      <figcaption>{{ $t('text.step3Duplication') }}</figcaption>
                    </figure>
              </div>
              <div class="divValidate buttons-container">
                  <ba-button class="primary" @click.native="showModal">{{ $t('action.apply') }}</ba-button>
              </div>
            </div>
            
            <ba-search-card legend="Recherche">
              <form @submit.prevent="handleFilterResultsDuplication">
                <div class="cols">
                  <div class="col-4">
                    <ba-select label="Type de pièce" :allow-empty="true" :empty-label="'Moteur & Boîte'" v-model="document_type">
                      <option :value="type.id" v-for="(type, index) in types" :key="`type_${index}`">{{ type.name }}</option>
                    </ba-select>
                  </div>
                  <div class="col-4"><ba-input type="text" label="Marque" v-model="brand"></ba-input></div>
                  <div class="col-4"><ba-input type="text" label="Modèle" v-model="version"></ba-input></div>
                  <div class="col-4">
                    <ba-select label="Energie" :allow-empty="true" :empty-label="'Tous'" v-model="energy">
                      <option v-for="(energy, index) in energies" :value="energy.name" :key="index">{{ energy.name }}</option>
                    </ba-select>
                  </div>

                  <div class="col-4">
                    <ba-select label="Etat" :allow-empty="true" :empty-label="'Tous'" v-model="status_document">
                      <option :value="row.id" v-for="(row, index) in status" :key="'status-'+index">{{ row.label }}</option>
                    </ba-select>
                  </div>
                  <div class="col-4"><ba-input type="text" label="Type moteur" v-model="motor_type"></ba-input></div>
                  <div class="col-4"><ba-input type="text" label="Type boîte" v-model="gearbox_type"></ba-input></div>
                  <div class="col-4"><ba-input type="text" label="Type Mine / Cnit" v-model="cnit"></ba-input></div>

                  <div class="col-4"><ba-input type="text" label="Ktype" v-model="ktype"></ba-input></div>
                  <div class="col-4"><ba-input type="text" label="Identifiant fiche article" v-model="document_id"></ba-input></div>
                  <div class="col-4">
                    <ba-select label="Type Mine / Cnit en attente" :allow-empty="true" :empty-label="'Tous'" v-model="cnit_mine_status">
                      <option v-for="(status, idx) in cnitMineStatus" :value="status.id" :key="`status-cnit-mine-${idx}`">{{ status.label }}</option>
                    </ba-select>
                  </div>
                  <div class="search-buttons-ctn">
                    <div class="buttons-container flex flex-end">
                      <div class="tooltip-container">
                          <span class="filter-link" @click="handleResetFilter"><ab-icon class="refresh" icon="refresh"></ab-icon></span>
                          <div class="tooltip">
                            {{ $t('action.resetFilter') }}
                          </div>
                      </div>
                      <ba-button class="primary" :disabled="filterOnGoing">{{ $t('action.search') }}</ba-button>
                    </div>
                  </div>
                </div>
              </form>
            </ba-search-card>

            

            
            <div style="margin:20px;display:flex;" >
                    <div style="margin-top:3px;margin-right:5px;">Informations de la fiche article à dupliquer :</div>
            </div>
             
          <div class="border-table">  
            <ba-table id="to-general-search" style="table-layout: fixed; width: 100%;">
              <template slot="colgroup">
                <col style="width: 80px;">
                <col style="width: 200px;">
                <col v-if="motor_type_check">
                <col v-if="motor_adapt_check">
                <col v-if="motor_observation_check">
                <col v-if="gearbox_type_check">
                <col v-if="gearbox_adapt_check">
                <col v-if="gearbox_observation_check">
                <col v-if="motor_img_check">
                <col v-if="motor_doc_check">
                <col v-if="gearbox_img_check">
                <col v-if="gearbox_doc_check">
                <col style="width: 50px;">
              </template>
              <template slot="body">
                 <tr>
                  <td><img class="img-fit" :src="handleGetBrandImage(selectedFA.aaa_brand)" @error='defaultImage' /></td>
                  <td class="brand-data limiteObservation">{{ selectedFA.aaa_brand }} {{ selectedFA.aaa_model }}<span class="subelement">{{ selectedFA.aaa_energy }} - {{ selectedFA.tecdoc_date_min | dateYear }}</span><span class="subelement">{{ $t('text.id') }} {{ selectedFA.doc_id || selectedFA.id }}</span></td>
                  <td v-if="motor_type_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="motor in getTypeAdaptability(selectedFA.motor_type)">
                        {{ motor }}
                      </li>
                    </ul>
                  </td>
                  <td v-if="motor_adapt_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="motor in getTypeAdaptability(selectedFA.motor_adapt)">
                        {{ motor }}
                      </li>
                    </ul>
                  </td>
                  <td class="limiteObservation" v-if="motor_observation_check"> <div>{{ selectedFA.motor_observation }}</div></td>
                  <td v-if="gearbox_type_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="gearbox in getTypeAdaptability(selectedFA.gearbox_type)">
                        {{ gearbox }}
                      </li>
                    </ul>
                  </td>
                  <td v-if="gearbox_adapt_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="gearbox in getTypeAdaptability(selectedFA.gearbox_adapt)">
                        {{ gearbox }}
                      </li>
                    </ul>
                  </td>
                  <td class="limiteObservation" v-if="gearbox_observation_check"> <div>{{ selectedFA.gearbox_observation }}</div></td>
                  <td v-if="motor_img_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="img in getCheckImgMotor()">
                        {{ img }}
                      </li>
                    </ul>
                  </td>
                  <td v-if="motor_doc_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="doc in getCheckDocMotor()">
                        {{ doc }}
                      </li>
                    </ul>
                  </td>
                  <td v-if="gearbox_img_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="img in getCheckImgGearbox()">
                        {{ img }}
                      </li>
                    </ul>
                  </td>
                  <td v-if="gearbox_doc_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="doc in getCheckDocGearbox()">
                        {{ doc }}
                      </li>
                    </ul>
                  </td>
                  <td />
                </tr>
                </template>
              <template slot="head">
                <tr>
                  <th v-if="checkCol(col)"  :class="[col.class, col.sortable ? 'sortable': '']" v-for="(col, index) in cols2" :key="index" @click="sortby(index)">
                    <span >{{ col.label }}<ab-icon :icon="ordercol(index)" v-if="col.sortable && ordercol(index)"></ab-icon></span>
                  </th>
                </tr>
              </template>
            </ba-table>
          </div>
            
                <div style="margin:20px;display:flex;justify-content: flex-end;" >
                    <div style="margin-top:3px;margin-right:5px;">Tout séléctionner :</div>
                    <ba-checkbox v-model="allSelect" :value="clickAllSelect" ></ba-checkbox>
                 </div>
                 
            <div class="loading" v-if="loading">
              <mo-loader :loading="loading"></mo-loader>
            </div>
            
            <ba-table v-if="documentsSelected.length && !loading" id="from-general-search" style="table-layout: fixed; width: 100%;">
              <template slot="colgroup">
                <col style="width: 80px;">
                <col style="width: 200px;">
                <col v-if="motor_type_check">
                <col v-if="motor_adapt_check">
                <col v-if="motor_observation_check">
                <col v-if="gearbox_type_check">
                <col v-if="gearbox_adapt_check">
                <col v-if="gearbox_observation_check">
                <col v-if="motor_img_check">
                <col v-if="motor_doc_check">
                <col v-if="gearbox_img_check">
                <col v-if="gearbox_doc_check">
                <col style="width: 50px;">
              </template>
              <template slot="body">
                <tr v-for="(document, index) in documentsSelected" :key="index">
                  <td><img class="img-fit" :src="handleGetBrandImage(document.aaa_brand)" @error='defaultImage' /></td>
                  <td class="brand-data limiteObservation">{{ document.aaa_brand }} {{ document.aaa_model }}<span class="subelement">{{ document.aaa_energy }} - {{ document.tecdoc_date_min | dateYear }}</span><span class="subelement">{{ $t('text.id') }} {{ document.doc_id || document.id }}</span></td>
                  <td v-if="motor_type_check">
                    <ul class="motor-gearbox limiteObservation">
                      <li v-for="motor in getTypeAdaptability(document.motor_type)">
                        {{ motor }}
                      </li>
                    </ul>
                  </td>
                  <td v-if="motor_adapt_check">
                    <ul class="motor-gearbox limiteObservation">
                      <li v-for="motor in getTypeAdaptability(document.motor_adapt)">
                        {{ motor }}
                      </li>
                    </ul>
                  </td>
                  <td v-if="motor_observation_check" class="limiteObservation"> <div>{{ document.motor_observation }}</div></td>
                  <td v-if="gearbox_type_check">
                    <ul class="motor-gearbox limiteObservation">
                      <li v-for="gearbox in getTypeAdaptability(document.gearbox_type)">
                        {{ gearbox }}
                      </li>
                    </ul>
                  </td>
                  <td v-if="gearbox_adapt_check">
                    <ul class="motor-gearbox limiteObservation">
                      <li v-for="gearbox in getTypeAdaptability(document.gearbox_adapt)">
                        {{ gearbox }}
                      </li>
                    </ul>
                  </td>
                  <td v-if="gearbox_observation_check" class="limiteObservation"> <div>{{ document.gearbox_observation }}</div></td>
                  <td v-if="motor_img_check" />
                  <td v-if="motor_doc_check" />
                  <td v-if="gearbox_img_check" />
                  <td v-if="gearbox_doc_check" />
                  <td style="vertical-align: middle; text-align: center;">
                    <ba-checkbox v-model="document.selectedDuplication" :value="document.selectedDuplication"></ba-checkbox>
                  </td>
                </tr>
              </template>
              <template slot="head">
                <tr>
                  <th v-if="checkCol(col)" :class="[col.class, col.sortable ? 'sortable': '']" v-for="(col, index) in cols2" :key="index" @click="sortby(index)">
                    <span>{{ col.label }}<ab-icon :icon="ordercol(index)" v-if="col.sortable && ordercol(index)"></ab-icon></span>
                  </th>
                </tr>
              </template>
            </ba-table>
            <div v-if="!documentsSelected.length && !loading">
              <p class="no-data">{{ $t('text.noDocumentsAvailable') }}</p>
            </div>
            <div class="buttons-container flex flex-end" style="margin:1rem;">
                <ba-button class="primary" @click.native="showModal">{{ $t('action.apply') }}</ba-button>
            </div>
              <footer >
              <div style="margin:20px;display:flex;justify-content: center;" >
                    Un maximum de 1000 fiches articles est affiché
                </div>
                <div class="buttons-container flex flex-end" style="margin:10px;">
            </div>
                
          </footer>

          <modal class="modal" name="popupSaveBulk" width="376px">
            <ba-card>
              <template slot="header">
                <span>{{ $t('sectionTitle.duplicateDocument') }}</span>
              </template>
              <template>
                <p >{{ $t('modal.duplicationDocumentValidation') }} </p>
              </template>
              <template slot="footer">
                <div class="buttons-container flex flex-end">
                  <ba-button class="primary" @click.native="closeModal">{{ $t('action.cancel') }}</ba-button>
                  <ba-button class="primary" :disabled="duplicationSend" @click.native="saveDuplication">{{ $t('action.confirm') }}</ba-button>
                </div>
              </template>
            </ba-card>
            </modal>
        </div>

         <div
          v-if="state == '4'"
          class="col-separator"
        >
          <div class="flex justify-center w-full relative">
              <div class="blockInfo">
                  <div class="divPrev">
                    <div class="tooltip-container">
                      <ba-button  class="no-button" @click.native="previousActionStep2">
                        <ab-icon class="prev" icon="prev" iconset="documentduplication"></ab-icon>
                      </ba-button>
                      <div class="tooltip">
                          {{ $t('action.previous') }}
                      </div>
                    </div>
                  </div>
                    <hr>
                    <figure>
                      <div class="StepNumber">
                        1
                      </div>
                      <figcaption class="stepTextDuplication">{{ $t('text.step1Duplication') }}</figcaption>
                    </figure>

     

                    <figure class="active">
                      <div class="StepNumber">
                        2
                      </div>
                      <figcaption>{{ $t('text.step3Duplication') }}</figcaption>
                    </figure>
              </div>
              
            </div>
            
            

            

            
            <div style="margin:20px;display:flex;" >
                    <div style="margin-top:3px;margin-right:5px;">Informations de la fiche article à dupliquer :</div>
            </div>
             
          <div class="border-table">  
            <ba-table>
              <template slot="colgroup">
                <col>
                <col class="brand">
              
              </template>
              <template slot="body">
                 <tr>
                  <td><img class="img-fit colonneLogo" :src="handleGetBrandImage(selectedFA.aaa_brand)" @error='defaultImage' /></td>
                  <td class="brand-data limiteObservation colonneVehicule">{{ selectedFA.aaa_brand }} {{ selectedFA.aaa_model }}<span class="subelement">{{ selectedFA.aaa_energy }} - {{ selectedFA.tecdoc_date_min | dateYear }}</span><span class="subelement">{{ $t('text.id') }} {{ selectedFA.doc_id || selectedFA.id }}</span></td>
                  <td ref="motorTS" v-if="motor_type_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="motor in getTypeAdaptability(selectedFA.motor_type)">
                        {{ motor }}
                      </li>
                    </ul>
                  </td>
                  <td ref="motorAS" v-if="motor_adapt_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="motor in getTypeAdaptability(selectedFA.motor_adapt)">
                        {{ motor }}
                      </li>
                    </ul>
                  </td>
                  <td ref="motorOS" class="limiteObservation" v-if="motor_observation_check"> <div>{{ selectedFA.motor_observation }}</div></td>
                  <td ref="gearboxTS" v-if="gearbox_type_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="gearbox in getTypeAdaptability(selectedFA.gearbox_type)">
                        {{ gearbox }}
                      </li>
                    </ul>
                  </td>
                  <td ref="gearboxAS" v-if="gearbox_adapt_check">
                    <ul class="motor-gearbox limiteObservation" >
                      <li v-for="gearbox in getTypeAdaptability(selectedFA.gearbox_adapt)">
                        {{ gearbox }}
                      </li>
                    </ul>
                  </td>
                  <td ref="gearboxOS" class="limiteObservation" v-if="gearbox_observation_check"> <div>{{ selectedFA.gearbox_observation }}</div></td>
                  <td ref="motorIS" v-if="motor_img_check">
                    <ul class="motor-gearbox limiteObservation" >
					<li v-for="img in getTypeAdaptability(selectedFA.motor_img)">
                        {{ img }}
                    </li>
                   
                    </ul>
                  </td>
				  <td ref="motorDOCIS" v-if="motor_doc_check">
                    <ul class="motor-gearbox limiteObservation" >
					<li v-for="doc in getTypeAdaptability(selectedFA.motor_doc)">
                        {{ doc }}
                    </li>
                   
                    </ul>
                  </td>
                  <td ref="gearboxIS" v-if="gearbox_img_check">
                    <ul class="motor-gearbox limiteObservation" >
						<li v-for="img in getTypeAdaptability(selectedFA.gearbox_img)">
							{{ img }}
						</li>
                    </ul>
                  </td>
				  <td ref="gearboxDOCIS" v-if="gearbox_doc_check">
                    <ul class="motor-gearbox limiteObservation" >
						<li v-for="img in getTypeAdaptability(selectedFA.gearbox_doc)">
							{{ doc }}
						</li>
                    </ul>
                  </td>
                    
                </tr>
                </template>
              <template slot="head">
                <tr>
                  <th v-if="checkCol(col)"  :class="[col.class, col.sortable ? 'sortable': '']" v-for="(col, index) in cols2" :key="index" @click="sortby(index)">
                    <span >{{ col.label }}<ab-icon :icon="ordercol(index)" v-if="col.sortable && ordercol(index)"></ab-icon></span>
                  </th>
                </tr>
              </template>
            </ba-table>
          </div>
            
                
                 
            <div class="loading" v-if="loading">
              <mo-loader :loading="loading"></mo-loader>
            </div>
            <div style="margin:10px 20px; display:flex; justify-content:end; align-items:center;">
                <div style="display:flex; align-items:center; gap:8px;">
                    <span>Tout sélectionner :</span>
                    <ba-checkbox id="allSelect" v-model="allSelect" :value="allSelect"></ba-checkbox>
                </div>
                <div class="buttons-container" style="display:flex; gap:8px;">
                    <ba-button class="primary" @click.native="showReplaceAllModal">{{ $t('action.replaceAllSelected') }}</ba-button>
                </div>
            </div>

            <div v-if="bulkReport" style="margin:0 20px 10px;" :style="{ color: bulkReportOk ? '#27ae60' : '#c0392b' }">
                {{ bulkReport.succeeded }}/{{ bulkReportTotal }} fiche(s) mise(s) à jour<span v-if="bulkReport.failed"> — échec sur : {{ bulkReport.failedIds.join(', ') }}</span><span v-if="bulkReport.untouchedIds.length"> — non modifiées : {{ bulkReport.untouchedIds.join(', ') }}</span><span v-if="bulkReport.remainingIds.length"> — non traitées : {{ bulkReport.remainingIds.join(', ') }}</span>
            </div>

            <div style="max-height: 600px;overflow-y:auto;">
            <ba-table v-if="documentsSelected.length && !loading" style="table-layout: fixed;">
              <template slot="colgroup">
				<col class="colonneLogo">
                <col class="colonneVehicule">
                <col :style="styleColonne1">
                <col :style="styleColonne2">
                <col :style="styleColonne3">
                <col :style="styleColonne4">
				<col :style="styleColonne5">
				<col :style="styleColonne6">
				<col :style="styleColonne7">
				<col :style="styleColonne8">
				<col :style="styleColonne9">
				<col :style="styleColonne10">
              </template>
              <template slot="body">
                <tr v-for="(document, index) in documentsSelected" :key="index">
					<td><img class="img-fit colonneLogo" :src="handleGetBrandImage(document.aaa_brand)" @error='defaultImage' /></td>
					<td class="brand-data limiteObservation colonneVehicule">{{ document.aaa_brand }} {{ document.aaa_model }}<span class="subelement">{{ document.aaa_energy }} - {{ document.tecdoc_date_min | dateYear }}</span><span class="subelement">{{ $t('text.id') }} {{ document.doc_id || document.id }}</span></td>
                 
                    <td v-if="motor_type_check" style="position:relative;min-width:130px;">
						<ul class="motor-gearbox limiteObservation" style="padding-bottom:40px">
						  <li v-for="motor in getTypeAdaptability(document.motor_type)">
							{{ motor }}
						  </li>
						  
						</ul>
						<div v-if="checkDif(document, 'motor_type')" class="buttons-container flex flex-end" style="position: absolute;bottom: 8px;right: 8px;">
							<ba-button class="primary" @click.native="updateDataDocument(document, 'motor_type')">{{ $t('action.replace') }}</ba-button>
						</div>
					</td>
					
					<td v-if="gearbox_type_check" style="position:relative;min-width:130px;">
						<ul class="motor-gearbox limiteObservation" style="padding-bottom:40px">
						  <li v-for="gearbox in getTypeAdaptability(document.gearbox_type)">
							{{ gearbox }}
						  </li>
						  
						</ul>
						<div v-if="checkDif(document, 'gearbox_type')" class="buttons-container flex flex-end" style="position: absolute;bottom: 8px;right: 8px;">
							<ba-button class="primary" @click.native="updateDataDocument(document, 'gearbox_type')">{{ $t('action.replace') }}</ba-button>
						</div>
					</td>
                  
                  
					<td v-if="motor_adapt_check" style="position:relative;min-width:130px;">
						<ul class="motor-gearbox limiteObservation" style="padding-bottom:40px">
						  <li v-for="motor in getTypeAdaptability(document.motor_adapt)">
							{{ motor }}
						  </li>
							
						</ul>
						<div v-if="checkDif(document, 'motor_adapt')" class="buttons-container flex flex-end" style="position: absolute;bottom: 8px;right: 8px;">
							<ba-button class="primary" @click.native="updateDataDocument(document, 'motor_adapt')">{{ $t('action.replace') }}</ba-button>
						</div>
					</td>
					
					<td v-if="gearbox_adapt_check" style="position:relative;min-width:130px;">
						<ul class="motor-gearbox limiteObservation" style="padding-bottom:40px">
						  <li v-for="gearbox in getTypeAdaptability(document.gearbox_adapt)">
							{{ gearbox }}
						  </li>
							
						</ul>
						<div v-if="checkDif(document, 'gearbox_adapt')" class="buttons-container flex flex-end" style="position: absolute;bottom: 8px;right: 8px;">
							<ba-button class="primary" @click.native="updateDataDocument(document, 'gearbox_adapt')">{{ $t('action.replace') }}</ba-button>
						</div>
					</td>
					
					<td v-if="motor_observation_check" class="limiteObservation" style="position:relative;min-width:130px;"> 
						<div style="padding-bottom:40px">{{ document.motor_observation }}</div>
						<div v-if="checkDif(document, 'motor_observation')" class="buttons-container flex flex-end" style="position: absolute;bottom: 8px;right: 8px;">
							<ba-button class="primary" @click.native="updateDataDocument(document, 'motor_observation')">{{ $t('action.replace') }}</ba-button>
						</div>
					</td>
					
					<td v-if="gearbox_observation_check" class="limiteObservation" style="position:relative;min-width:130px;"> 
						<div style="padding-bottom:40px">{{ document.gearbox_observation }}</div>
						<div v-if="checkDif(document, 'gearbox_observation')" class="buttons-container flex flex-end" style="position: absolute;bottom: 8px;right: 8px;">
							<ba-button class="primary" @click.native="updateDataDocument(document, 'gearbox_observation')">{{ $t('action.replace') }}</ba-button>
						</div>
					</td>
					
					<td v-if="motor_img_check" class="limiteObservation" style="position:relative;min-width:130px;"> 
						<ul class="motor-gearbox limiteObservation" >
					   <li v-for="img in getTypeAdaptability(document.motor_img)">
                        {{ img }}
                    </li>
					</ul>
					   <div v-if="checkDif(document, 'motor_img')" class="buttons-container flex flex-end" style="position: absolute;bottom: 8px;right: 8px;">
							<ba-button class="primary" @click.native="updateDataDocument(document, 'motor_img')">{{ $t('action.replace') }}</ba-button>
						</div>
					</td>
					
					<td v-if="motor_doc_check" class="limiteObservation" style="position:relative;min-width:130px;"> 
						<ul class="motor-gearbox limiteObservation" >
					   <li v-for="doc in getTypeAdaptability(document.motor_doc)">
                        {{ doc }}
                    </li>
					</ul>
					   <div v-if="checkDif(document, 'motor_doc')" class="buttons-container flex flex-end" style="position: absolute;bottom: 8px;right: 8px;">
							<ba-button class="primary" @click.native="updateDataDocument(document, 'motor_doc')">{{ $t('action.replace') }}</ba-button>
						</div>
					</td>
					
					<td v-if="gearbox_img_check" class="limiteObservation" style="position:relative;min-width:130px;"> 
					   <div style="padding-bottom:40px">{{  document.gearbox_img }}</div>
					   <div v-if="checkDif(document, 'gearbox_img')" class="buttons-container flex flex-end" style="position: absolute;bottom: 8px;right: 8px;">
							<ba-button class="primary" @click.native="updateDataDocument(document, 'gearbox_img')">{{ $t('action.replace') }}</ba-button>
						</div>
					</td>
					
					<td v-if="gearbox_doc_check" class="limiteObservation" style="position:relative;min-width:130px;"> 
					   <div style="padding-bottom:40px">{{  document.gearbox_doc }}</div>
					   <div v-if="checkDif(document, 'gearbox_doc')" class="buttons-container flex flex-end" style="position: absolute;bottom: 8px;right: 8px;">
							<ba-button class="primary" @click.native="updateDataDocument(document, 'gearbox_doc')">{{ $t('action.replace') }}</ba-button>
						</div>
					</td>
					
					
					<td id="actions" style="position:relative;min-width:130px;">
						<div style="padding: 20px; display:flex; justify-content: flex-end;">
							<div class="buttons-container flex flex-end" style="position: absolute;top: 8px;right: 8px;">
								<ba-button class="primary" @click.native="updateAllDataDocument(document)">{{ $t('action.replaceAll') }}</ba-button>
							</div>
						</div>
						<div style="position:absolute; top:50%; right:8px; transform:translateY(-50%);width: 50%;">
							<ba-checkbox v-model="document.selectedDuplication" :value="document.selectedDuplication"></ba-checkbox>
						</div>
						<div style="padding: 20px; display:flex; justify-content: flex-end;">
							<div class="buttons-container flex flex-end" style="position: absolute;bottom: 8px;right: 8px;">
								<ba-button class="primary danger " @click.native="excludeDataDocument(document)">{{ $t('action.exlure') }}</ba-button>
							</div>
						</div>
					</td>
                </tr>
              </template>
              <template slot="head">
                <tr>
                  <th v-if="checkCol(col)"  :class="[col.class, col.sortable ? 'sortable': '']" v-for="(col, index) in cols2" :key="index" @click="sortby(index)">
                    <span>{{ col.label }}<ab-icon :icon="ordercol(index)" v-if="col.sortable && ordercol(index)"></ab-icon></span>
                  </th>
                </tr>
              </template>
            </ba-table>
			</div>
            <div v-if="!documentsSelected.length && !loading">
              <p class="no-data">{{ $t('text.noDocumentsAvailable') }}</p>
            </div>
              <footer >
              <div style="margin:20px;display:flex;justify-content: center;" >
                    Un maximum de 1000 fiches articles est affiché
                </div>
                <div class="buttons-container flex flex-end" style="margin:10px;">
            </div>
                

          </footer>

          <modal class="modal" name="popupSaveGrid" width="376px">
            <ba-card>
              <template slot="header">
                <span>{{ $t('sectionTitle.duplicateDocument') }}</span>
              </template>
              <template>
                <p >{{ $t('modal.duplicationDocumentValidation') }} </p>
              </template>
              <template slot="footer">
                <div class="buttons-container flex flex-end">
                  <ba-button class="primary" @click.native="closeModal">{{ $t('action.cancel') }}</ba-button>
                  <ba-button class="primary" :disabled="duplicationSend" @click.native="saveDuplication">{{ $t('action.confirm') }}</ba-button>
                </div>
              </template>
            </ba-card>
            </modal>

          <modal class="modal" name="popupReplaceAllSelected" width="376px">
            <ba-card>
              <template slot="header">
                <span>{{ $t('action.replaceAllSelected') }}</span>
              </template>
              <template>
                <p>{{ $t('modal.replaceAllSelectedConfirm') }}</p>
              </template>
              <template slot="footer">
                <div class="buttons-container flex flex-end">
                  <ba-button class="primary" @click.native="$modal.hide('popupReplaceAllSelected')">{{ $t('action.cancel') }}</ba-button>
                  <ba-button class="primary" @click.native="confirmReplaceAllSelected">{{ $t('action.confirm') }}</ba-button>
                </div>
              </template>
            </ba-card>
          </modal>
        </div>




    <modal class="modal" name="popupBulkProgress" width="420px" height="auto" :clickToClose="false">
      <ba-card>
        <template slot="header">
          <span>{{ $t('sectionTitle.bulkReplaceProgress') }}</span>
        </template>
        <template>
          <p>{{ $t('modal.bulkReplaceInProgress') }}</p>
          <p v-if="bulkTotal"><strong>{{ bulkProcessed }}</strong> / {{ bulkTotal }} fiche(s) article(s)</p>
          <p v-if="bulkStopped">{{ $t('modal.bulkReplaceStopping') }}</p>
          <mo-loader :loading="true"></mo-loader>
        </template>
        <template slot="footer">
          <div class="buttons-container flex flex-end">
            <ba-button class="primary danger" :disabled="bulkStopped" @click.native="stopBulkReplace">{{ $t('action.stop') }}</ba-button>
          </div>
        </template>
      </ba-card>
    </modal>

    <modal class="modal" name="popupBulkReport" width="480px" height="auto" :scrollable="true">
      <ba-card>
        <template slot="header">
          <span>{{ $t('sectionTitle.bulkReplaceReport') }}</span>
        </template>
        <template>
          <div style="max-height:50vh; overflow-y:auto;">
          <p v-if="bulkReport" :style="{ color: bulkReportOk ? '#27ae60' : '#c0392b' }">
            <strong>{{ bulkReport.succeeded }}/{{ bulkReportTotal }}</strong>
            fiche(s) mise(s) à jour
          </p>
          <p v-if="bulkReport && bulkReport.problem === 'nothing'">{{ $t('modal.bulkReplaceNothingApplied') }}</p>
          <p v-if="bulkReport && bulkReport.problem === 'unexpected'">{{ $t('modal.bulkReplaceUnexpected') }}</p>
          <p v-if="bulkReport && bulkReport.problem === 'stopped'">{{ $t('modal.bulkReplaceStopped') }}</p>
          <p v-if="bulkReport && bulkReport.problem === 'aborted'">{{ $t('modal.bulkReplaceAborted') }}</p>
          <p v-if="bulkReport && !bulkReport.succeeded && bulkReport.untouchedIds.length">{{ $t('modal.bulkReplaceNoopApplied') }}</p>
          <div v-if="bulkReport && bulkReport.skippedByDoc.length">
            <p>{{ $t('modal.bulkReplaceSkippedAttachments') }}</p>
            <ul style="margin:0 0 8px 16px;">
              <li v-for="entry in bulkReport.skippedByDoc" :key="`skip_${entry.id}`" style="word-break:break-word;">
                <strong>{{ $t('text.id') }} {{ entry.id }}</strong> — {{ entry.labels.join(', ') }}
              </li>
            </ul>
          </div>
          <div v-if="bulkReport && bulkReport.untouchedIds.length">
            <p>{{ $t('modal.bulkReplaceUntouchedList') }}</p>
            <p style="word-break:break-all;">{{ bulkReport.untouchedIds.join(', ') }}</p>
          </div>
          <div v-if="bulkReport && bulkReport.remainingIds.length">
            <p>{{ $t('modal.bulkReplaceRemainingList') }}</p>
            <p style="word-break:break-all;">{{ bulkReport.remainingIds.join(', ') }}</p>
            <p>{{ $t('modal.bulkReplaceRetryHint') }}</p>
          </div>
          <div v-if="bulkReport && bulkReport.failed">
            <p>{{ $t('modal.bulkReplaceFailedList') }}</p>
            <ul style="margin:0 0 8px 16px;">
              <li v-for="entry in bulkReport.failures" :key="`fail_${entry.id}`" style="word-break:break-word;">
                <strong>{{ $t('text.id') }} {{ entry.id }}</strong> — {{ entry.message }}
              </li>
            </ul>
            <p>{{ $t('modal.bulkReplaceRetryHint') }}</p>
          </div>
          </div>
        </template>
        <template slot="footer">
          <div class="buttons-container flex flex-end">
            <ba-button class="primary" @click.native="$modal.hide('popupBulkReport')">{{ $t('action.close') }}</ba-button>
          </div>
        </template>
      </ba-card>
    </modal>

    <ab-iconset iconset="documentduplication">
      <g id="prev">
        <path d="M5.33284 12.9365L16.0131 23.6166C16.2602 23.8638 16.5899 24 16.9415 24C17.2931 24 17.6229 23.8638 17.8699 23.6166L18.6564 22.8303C19.1682 22.3179 19.1682 21.4851 18.6564 20.9735L9.68793 12.005L18.6664 3.02651C18.9134 2.77929 19.0498 2.44974 19.0498 2.09832C19.0498 1.74652 18.9134 1.41696 18.6664 1.16955L17.8799 0.383411C17.6326 0.136194 17.3031 3.14931e-07 16.9515 3.45669e-07C16.5999 3.76407e-07 16.2701 0.136194 16.0231 0.383411L5.33284 11.0733C5.08524 11.3213 4.94924 11.6524 4.95002 12.0044C4.94924 12.3578 5.08524 12.6887 5.33284 12.9365Z" />
      </g>
      <g id="next">
        <path d="M18.6672 11.0635L7.98685 0.383419C7.73983 0.136202 7.41008 7.62939e-06 7.05847 7.62939e-06C6.70686 7.62939e-06 6.37711 0.136202 6.13009 0.383419L5.34356 1.16975C4.83176 1.68214 4.83176 2.51491 5.34356 3.02652L14.3121 11.995L5.33361 20.9735C5.08658 21.2207 4.9502 21.5503 4.9502 21.9017C4.9502 22.2535 5.08658 22.583 5.33361 22.8305L6.12014 23.6166C6.36735 23.8638 6.69691 24 7.04852 24C7.40013 24 7.72988 23.8638 7.9769 23.6166L18.6672 12.9267C18.9148 12.6787 19.0508 12.3476 19.05 11.9956C19.0508 11.6423 18.9148 11.3113 18.6672 11.0635Z" />
      </g>
      <g id="start">
        <path d="M5.64825 12.855L16.2613 23.4678C16.5067 23.7135 16.8344 23.8488 17.1838 23.8488C17.5332 23.8488 17.8609 23.7135 18.1063 23.4678L18.8879 22.6865C19.3965 22.1773 19.3965 21.3498 18.8879 20.8414L9.9759 11.9294L18.8978 3.00745C19.1433 2.76179 19.2788 2.43431 19.2788 2.08511C19.2788 1.73552 19.1433 1.40804 18.8978 1.16219L18.1162 0.380999C17.8706 0.135339 17.5431 3.7626e-06 17.1937 3.79314e-06C16.8443 3.82369e-06 16.5166 0.135339 16.2712 0.381L5.64825 11.0035C5.4022 11.25 5.26706 11.579 5.26784 11.9288C5.26706 12.2799 5.4022 12.6088 5.64825 12.855Z" />
        <rect x="1.96753" y="7.62939e-06" width="3.54098" height="24" rx="1.77049" />
      </g>
      <g id="validate">
        <path d="M9.19003 20.9656C8.96094 21.196 8.64837 21.3246 8.32369 21.3246C7.99901 21.3246 7.68645 21.196 7.45735 20.9656L0.538518 14.0456C-0.179506 13.3276 -0.179506 12.1633 0.538518 11.4466L1.40486 10.58C2.12311 9.86203 3.28608 9.86203 4.00411 10.58L8.32369 14.8999L19.9958 3.22748C20.7141 2.50946 21.8782 2.50946 22.5951 3.22748L23.4614 4.09405C24.1795 4.81207 24.1795 5.97617 23.4614 6.69307L9.19003 20.9656Z"/>
      </g>
    </ab-iconset>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Paginate from 'vuejs-paginate';
import { AbIcon, AbIconset, BaButton, BaCard, BaDropdown, BaInput, BaSearch, BaSearchCard, BaSelect, BaStateLabel, BaTable, BaCheckbox } from '@ab/basic-components';
import MoLoader from '@/components/loader/mo-loader.vue';
import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';
import MoSpeedometer from '@/components/tool/mo-speedometer.vue';

import paginationMixin from '@/components/mixins/pagination.js';
import requestMixin from '@/components/mixins/request.js';
import searchMixin from '@/components/mixins/search.js';
import sortableMixin from '@/components/mixins/sortable.js';
import { generateSearchWatcher } from '@/assets/js/helpers.js';


import BaTextareaPerso from '@/components/form/input/ba-textarea.vue';

const BULK_CHUNK_SIZE = 25;

export default {
  name: 'DocumentList-duplication',
  components: {
    AbIcon,
    AbIconset, 
    BaButton,
    BaCard,
    BaDropdown,
    BaInput,
    BaSearch,
    BaSearchCard,
    BaSelect,
    BaStateLabel,
    BaTable,
    MoLoader,
    MoPageheader,
    MoSpeedometer,
    Paginate,
    BaTextareaPerso,
    BaCheckbox
  },
  mixins: [ paginationMixin, requestMixin, searchMixin, sortableMixin ],
  async mounted() {
    /* Get documents counter */
    this.$store.dispatch('getDocumentCounter');
    /* Get energies to fill dedicated search options */
    this.$store.dispatch('getEnergies');
    /* Get document status */
    this.$store.dispatch('getDocumentStatus');
    this.$store.dispatch('getDocumentTypes');
	var tmpBrandInfo = await this.$store.dispatch('getInfoBrand');
	this.infoBrand = [];
	if(tmpBrandInfo != null) {
		this.infoBrand = tmpBrandInfo.brand;
	}

	if(this.document_type2 != null ) {
		this.document_type2 = this.types[1].id;
	}
	
  },
  data() {
    return {
        duplicationSend:false,
        bulkReport: null,
        bulkTotal: 0,
        bulkProcessed: 0,
        bulkStopped: false,
        allSelect: false,
        faExclue: false,
		gearbox_img_check:true,
		gearbox_doc_check:true,
        gearbox_observation_check:true,
        gearbox_type_check:true,
        gearbox_adapt_check:true,
		motor_img_check:true,
		motor_doc_check:true,
        motor_observation_check:true,
        motor_type_check:true,
        motor_adapt_check:true,
        modeSearch:0,
      state:1,
	  infoBrand:[],
	  selectedBrand: null,
                listFilterBrand: [],
      selectedFA:null,
      img_motor:[],
      img_gearbox:[],
	  doc_motor:[],
      doc_gearbox:[],
      stateMax:3,
      userRole: this.$store.getters.getUserRole,
      documentId: '',
      documents:[],
      documentsSelected:[],
      documentsCount: '',
      filterOnGoing: false,
      filterOnGoing2:false,
	  styleColonne:'position:relative;',
	  styleColonne1:'position:relative;',
	  styleColonne2:'position:relative;',
	  styleColonne3:'position:relative;',
	  styleColonne4:'position:relative;',
	  styleColonne5:'position:relative;',
	  styleColonne6:'position:relative;',
	  styleColonne7:'position:relative;',
	  styleColonne8:'position:relative;',
	  styleColonne9:'position:relative;',
	  styleColonne10:'position:relative;',
      cnitMineStatus: [
        { id: 1, label: 'Non' },
        { id: 2, label: 'Oui' },
      ],
      matriculationSearch: '',
      ...this.generateSearchData([
        'brand',
        'brand2',
        'ktype',
        'cnit',
        'cnit_mine_status',
        'document_id',
        'document_type',
        'document_type2',
        'motor_gearbox_type2',
        'document_id2',
        'energy',
        'gearbox_type',
        'motor_type',
        'status_document',
        'version'
      ]),
      cols: [
        { label: '', sortable: false, sorted: '', key: '', class: '' },
        { label: 'Véhicule', sortable: false, sorted: '', key: 'aaa_brand', class: '' },
        { label: 'Type moteur', sortable: false, sorted: '', key: 'motor_type', class: '' },
        { label: 'Adaptabilité moteur', sortable: false, sorted: '', key: 'motor_adapt', class: '' },
        { label: 'Observation moteur', sortable: false, sorted: '', key: 'motor_observateur', class: 'limiteObservation' },
        { label: 'Type boîte', sortable: false, sorted: '', key: 'gearbox_type', class: '' },
        { label: 'Adaptabilité boîte', sortable: false, sorted: '', key: 'gearbox_adapt', class: '' },
        { label: 'Observation boîte', sortable: false, sorted: '', key: 'gearbox_observateur', class: 'limiteObservation' },
        { label: 'Nb Images', sortable: true, sorted: '', key: 'nbImg', class: '' },
        { label: 'Nb Docs', sortable: true, sorted: '', key: 'nbDoc', class: '' },

        { label: '', sortable: false, sorted: '', key: '', class: '' },
      ],
	  colsbis: [
        { label: '', sortable: false, sorted: '', key: '', class: '' },
        { label: 'Véhicule', sortable: true, sorted: '', key: 'aaa_brand', class: '' },
        { label: 'Type moteur', sortable: true, sorted: '', key: 'motor_type', class: '' },
        { label: 'Adaptabilité moteur', sortable: true, sorted: '', key: 'motor_adapt', class: '' },
        { label: 'Observation moteur', sortable: false, sorted: '', key: 'motor_observateur', class: 'limiteObservation' },
        { label: 'Type boîte', sortable: true, sorted: '', key: 'gearbox_type', class: '' },
        { label: 'Adaptabilité boîte', sortable: true, sorted: '', key: 'gearbox_adapt', class: '' },
        { label: 'Observation boîte', sortable: false, sorted: '', key: 'gearbox_observateur', class: 'limiteObservation' },
       
        { label: '', sortable: false, sorted: '', key: '', class: '' },
      ],
      cols2: [
        { label: '', sortable: false, sorted: '', key: '', class: 'colonneLogo' },
        { label: 'Véhicule', sortable: true, sorted: '', key: 'aaa_brand', class: 'colonneVehicule' },
        { label: 'Type moteur', sortable: true, sorted: '', key: 'motor_type', class: '' },
        { label: 'Adaptabilité moteur', sortable: true, sorted: '', key: 'motor_adapt', class: '' },
        { label: 'Observation moteur', sortable: false, sorted: '', key: 'motor_observateur', class: 'limiteObservation' },
        { label: 'Type boîte', sortable: true, sorted: '', key: 'gearbox_type', class: '' },
        { label: 'Adaptabilité boîte', sortable: true, sorted: '', key: 'gearbox_adapt', class: '' },
        { label: 'Observation boîte', sortable: false, sorted: '', key: 'gearbox_observateur', class: 'limiteObservation' },
        { label: 'Images Moteur', sortable: false, sorted: '', key: 'motor_img', class: '' },
		{ label: 'Documents Moteur', sortable: false, sorted: '', key: 'motor_doc', class: '' },
        { label: 'Images boîte', sortable: false, sorted: '', key: 'gearbox_img', class: '' },
		{ label: 'Documents boîte', sortable: false, sorted: '', key: 'gearbox_doc', class: '' },
        
        { label: '', sortable: false, sorted: '', key: '', class: 'colonneEmptyEnd' },
      ],
      cols3: [
		{ label: '', sortable: false, sorted: '', key: '', class: 'colonneLogo' , styleColonne:'' },
        { label: 'Véhicule', sortable: true, sorted: '', key: 'aaa_brand', class: 'colonneVehicule' , styleColonne:'' },
        { label: 'Type', sortable: true, sorted: '', key: 'motor_type', class: '' , styleColonne:'' },
        { label: 'Adaptabilité', sortable: true, sorted: '', key: 'motor_adapt', class: '' , styleColonne:'' },
        { label: 'Observation', sortable: false, sorted: '', key: 'motor_observateur', class: 'limiteObservation' , styleColonne:'' },
        { label: 'Images', sortable: false, sorted: '', key: 'motor_img', class: '' , styleColonne:'' },
        { label: '', sortable: false, sorted: '', key: '', class: 'colonneEmptyEnd' , styleColonne:'' },
      ],
    };
  },
  computed: {
    ...mapState({ counter: state => state.documents.counter }),
//    ...mapState({ documents: state => state.documents.documents }),
    ...mapState({ energies: state => state.documents.energies }),
    ...mapState({ loading: state => state.documents.loading }),
    ...mapState({ status: state => state.documents.status }),
    ...mapState({ types: state => state.documents.types }),
    bulkReportTotal() {
      if(!this.bulkReport) {
        return 0;
      }
      return this.bulkReport.succeeded
        + this.bulkReport.failed
        + this.bulkReport.untouchedIds.length
        + this.bulkReport.remainingIds.length;
    },
    bulkReportOk() {
      return !!(this.bulkReport
        && this.bulkReport.succeeded
        && !this.bulkReport.failed
        && !this.bulkReport.untouchedIds.length
        && !this.bulkReport.remainingIds.length);
    },
  },
  methods: {
	  checkDif(documentInfo , type) {


		var diff = true;
		const sourceValue = this.selectedFA[type];
		const targetValue = documentInfo[type];

		let isSourceEmpty = false;
		if (sourceValue === null || sourceValue === undefined || sourceValue === "") {
			isSourceEmpty = true;
		}

		let isTargetEmpty = false;
		if (targetValue === null || targetValue === undefined || targetValue === "") {
			isTargetEmpty = true;
		}

		if (isSourceEmpty && isTargetEmpty) {
			return false;
		}
		if (isSourceEmpty && !isTargetEmpty) {
			return true;
		}
		if (!isSourceEmpty && isTargetEmpty) {
			return true;
		}
		switch(type) {
			case "motor_type": 
				if(this.selectedFA.motor_type == documentInfo.motor_type) {
					diff = false;
				}
				break;
			case "gearbox_type": 
				if(this.selectedFA.gearbox_type == documentInfo.gearbox_type) {
					diff = false;
				}
				break;
			case "motor_adapt": 
			 
				if(this.selectedFA.motor_adapt == documentInfo.motor_adapt) {
					diff = false;
				}
				break;
			case "gearbox_adapt": 
				if(this.selectedFA.gearbox_adapt == documentInfo.gearbox_adapt) {
					diff = false;
				}
				break;
			case "motor_observation": 
				if(this.selectedFA.motor_observation == documentInfo.motor_observation) {
					diff = false;
				}
				break;
			case "gearbox_observation": 
				if(this.selectedFA.gearbox_observation == documentInfo.gearbox_observation) {
					diff = false;
				}
				break;
			case "motor_img": 
				if(documentInfo.motor_img != null) {
					var docImg = documentInfo.motor_img.split(", ");
					var tmpImgSource = this.selectedFA.motor_img.split(", ");
						diff = false;
						var searchImg = false;
						if(tmpImgSource.length != docImg.length) {
							diff = true;
						}
						else {
							for(var j in tmpImgSource) {
								searchImg = false
								for(var k in docImg) {
									if(docImg[k] == tmpImgSource[j]) {
										searchImg = true;
										break;
									}
								}
								if(!searchImg) {
									diff = true;
									break;
								}
							}
						}
				}
				break;
			case "motor_doc": 
				if(documentInfo.motor_doc != null) {
					var docImg = documentInfo.motor_doc.split(", ");
					var tmpDocSource = this.selectedFA.motor_doc.split(", ");
						diff = false;
						var searchDoc = false;
						if(tmpDocSource.length != docImg.length) {
							diff = true;
						}
						else {
							for(var j in tmpDocSource) {
								searchDoc = false
								for(var k in docImg) {
									if(docImg[k] == tmpDocSource[j]) {
										searchDoc = true;
										break;
									}
								}
								if(!searchDoc) {
									diff = true;
									break;
								}
							}
						}
				}
				break;
				case "gearbox_img": 
				if(documentInfo.gearbox_img != null) {
					var docImg = documentInfo.gearbox_img.split(", ");
					var tmpImgSource = this.selectedFA.gearbox_img.split(", ");
						diff = false;
						var searchImg = false;
						if(tmpImgSource.length != docImg.length) {
							diff = true;
						}
						else {
							for(var j in tmpImgSource) {
								searchImg = false
								for(var k in docImg) {
									if(docImg[k] == tmpImgSource[j]) {
										searchImg = true;
										break;
									}
								}
								if(!searchImg) {
									diff = true;
									break;
								}
							}
						}
				}
				break;
			case "gearbox_doc": 
				if(documentInfo.gearbox_doc != null) {
					var docImg = documentInfo.gearbox_doc.split(", ");
					var tmpDocSource = this.selectedFA.gearbox_doc.split(", ");
						diff = false;
						var searchDoc = false;
						if(tmpDocSource.length != docImg.length) {
							diff = true;
						}
						else {
							for(var j in tmpDocSource) {
								searchDoc = false
								for(var k in docImg) {
									if(docImg[k] == tmpDocSource[j]) {
										searchDoc = true;
										break;
									}
								}
								if(!searchDoc) {
									diff = true;
									break;
								}
							}
						}
				}
				break;
			default:
			break;
		}
		
		return diff;
	  },
	  generationtailleColonne(nbc) {

		  var c = 100 / nbc; 
		  var withtmp = document.documentElement.clientWidth - 450 - (42*2);
		  
		  this.styleColonne = "position:relative;width:"+(withtmp/nbc)+"px;";
		  
		
	  },
	  buildFieldPayload(type) {
		var tmpParam = {};
		switch(type) {
			case "motor_type":
				tmpParam.motor_type = this.selectedFA.motor_type ? this.selectedFA.motor_type.split(',').map(e => e.trim()) : [];
				break;
			case "gearbox_type":
				tmpParam.gearbox_type = this.selectedFA.gearbox_type ? this.selectedFA.gearbox_type.split(',').map(e => e.trim()) : [];
				break;
			case "motor_adapt":
				tmpParam.motor_adaptability = this.selectedFA.motor_adapt ? this.selectedFA.motor_adapt.split(',').map(e => e.trim()) : [];
				break;
			case "gearbox_adapt":
				tmpParam.gearbox_adaptability = this.selectedFA.gearbox_adapt ? this.selectedFA.gearbox_adapt.split(',').map(e => e.trim()) : [];
				break;

			case "motor_observation":
				tmpParam.motor_observation = typeof this.selectedFA.motor_observation === 'undefined'
					? null : this.selectedFA.motor_observation;
				break;
			case "gearbox_observation":
				tmpParam.gearbox_observation = typeof this.selectedFA.gearbox_observation === 'undefined'
					? null : this.selectedFA.gearbox_observation;
				break;
			case "motor_img":
				tmpParam.idsource = this.selectedFA.doc_id;
				tmpParam.motor_img = this.selectedFA.motor_img;
				break;
			case "motor_doc":
				tmpParam.idsource = this.selectedFA.doc_id;
				tmpParam.motor_doc = this.selectedFA.motor_doc;
				break;
			case "gearbox_img":
				tmpParam.idsource = this.selectedFA.doc_id;
				tmpParam.gearbox_img = this.selectedFA.gearbox_img;
				break;
			case "gearbox_doc":
				tmpParam.idsource = this.selectedFA.doc_id;
				tmpParam.gearbox_doc = this.selectedFA.gearbox_doc;
				break;
			default:
				break;
		}
		return tmpParam;
	  },
	  applyLocalChange(documentInfo, type) {
		switch(type) {
			case "motor_type": documentInfo.motor_type = this.selectedFA.motor_type; break;
			case "gearbox_type": documentInfo.gearbox_type = this.selectedFA.gearbox_type; break;
			case "motor_adapt": documentInfo.motor_adapt = this.selectedFA.motor_adapt; break;
			case "gearbox_adapt": documentInfo.gearbox_adapt = this.selectedFA.gearbox_adapt; break;
			case "motor_observation": documentInfo.motor_observation = this.selectedFA.motor_observation; break;
			case "gearbox_observation": documentInfo.gearbox_observation = this.selectedFA.gearbox_observation; break;
			case "motor_img": documentInfo.motor_img = this.selectedFA.motor_img; break;
			case "motor_doc": documentInfo.motor_doc = this.selectedFA.motor_doc; break;
			case "gearbox_img": documentInfo.gearbox_img = this.selectedFA.gearbox_img; break;
			case "gearbox_doc": documentInfo.gearbox_doc = this.selectedFA.gearbox_doc; break;
			default: break;
		}
	  },
	  changedFields(documentInfo) {
		var fields = this.document_type2 == 1
			? [ "motor_type", "motor_adapt", "motor_observation", "motor_img", "motor_doc" ]
			: [ "gearbox_type", "gearbox_adapt", "gearbox_observation", "gearbox_img", "gearbox_doc" ];
		return fields.filter(field => this.checkDif(documentInfo, field));
	  },
	  async updateDataDocument(documentInfo, type) {
		var tmpParam = this.buildFieldPayload(type);
		tmpParam.id = documentInfo.doc_id;
		tmpParam.typeChange = type;

		try {
			const data = await this.$store.dispatch('updateSpecificDocument', tmpParam);
			if(this.wasWritten(data, type)) {
				this.applyLocalChange(documentInfo, type);
			}
			this.warnSkippedAttachments(data);
		} catch(e) {
			return false;
		}
		return true;
	  },
	  async updateAllDataDocument(documentInfo) {
		var types = this.changedFields(documentInfo);
		if(!types.length) {
			return false;
		}

		var tmpParam = { id: documentInfo.doc_id, typeChange: "all" };
		types.forEach(type => Object.assign(tmpParam, this.buildFieldPayload(type)));

		try {
			const data = await this.$store.dispatch('updateSpecificDocument', tmpParam);
			types.filter(type => this.wasWritten(data, type))
				.forEach(type => this.applyLocalChange(documentInfo, type));
			this.warnSkippedAttachments(data);
		} catch(e) {
			return false;
		}
		return true;
	  },
	  wasWritten(data, type) {
		const attachmentTypes = {
			motor_img: 'attachments:1',
			gearbox_img: 'attachments:2',
			motor_doc: 'attachments:3',
			gearbox_doc: 'attachments:4'
		};
		if(!attachmentTypes[type]) {
			return true;
		}
		const applied = data && data.appliedAttachments;
		return Array.isArray(applied) && applied.indexOf(attachmentTypes[type]) !== -1;
	  },
	  appliedToFields(applied) {
		const map = {
			motorType: 'motor_type',
			motorAdaptability: 'motor_adapt',
			gearboxType: 'gearbox_type',
			gearboxAdaptability: 'gearbox_adapt',
			motor_observation: 'motor_observation',
			gearbox_observation: 'gearbox_observation',
			'attachments:1': 'motor_img',
			'attachments:2': 'gearbox_img',
			'attachments:3': 'motor_doc',
			'attachments:4': 'gearbox_doc'
		};
		return (applied || []).map(entry => map[entry]).filter(field => !!field);
	  },
	  warnSkippedAttachments(data) {
		const skipped = data && data.skippedAttachments;
		if(skipped && skipped.length) {
			this.$store.dispatch('displaySnackbar', {
				text: `Pièces jointes non copiées (fichier introuvable) : ${skipped.join(', ')}`,
				mode: 'error'
			});
		}
	  },
	  async excludeDataDocument(documentInfo) {
		
		var tmpParam = {};
		tmpParam.id = documentInfo.doc_id;	
	  	var data = await this.$store.dispatch('excludedDataDocument', tmpParam);

		var newListDoc = [];
		for(var i in this.documentsSelected) {
			if(this.documentsSelected[i].doc_id != documentInfo.doc_id) {
				newListDoc.push(this.documentsSelected[i]);
			}
		}
		this.documentsSelected = newListDoc;

	  },
	  stopBulkReplace() {
      this.bulkStopped = true;
	  },
	  async runDuplicationChunks(info, ids) {
      const results = [];
      let problem = null;
      let index = 0;

      while(index < ids.length) {
        if(this.bulkStopped) {
          problem = 'stopped';
          break;
        }

        const chunk = ids.slice(index, index + BULK_CHUNK_SIZE);
        let report = null;
        try {
          report = await this.$store.dispatch('duplicateDocument', { ...info, documentUpdate: chunk });
        } catch(e) {
          const reason = e && e.isTimeout ? 'délai dépassé'
            : (e && e.isNetwork ? 'API injoignable' : ((e && e.message) || 'erreur inconnue'));
          chunk.forEach(id => results.push({
            document_id: id, ok: false, applied: [], skippedAttachments: [], message: reason
          }));
          index += chunk.length;
          this.bulkProcessed = index;
          problem = 'aborted';
          break;
        }

        if(!report || !Array.isArray(report.results) || !Array.isArray(report.appliedFields)) {
          problem = 'unexpected';
          break;
        }
        if(!report.appliedFields.length) {
          problem = 'nothing';
          break;
        }

        results.push(...report.results);
        index += chunk.length;
        this.bulkProcessed = index;
      }

      return { results, remaining: ids.slice(index), problem };
	  },
	  async updateAllDataDocumentSelected() {
      const selected = this.documentsSelected.filter(d => d.selectedDuplication);
      if(!selected.length) {
        return;
      }

      const changed = new Set();
      selected.forEach(doc => this.changedFields(doc).forEach(field => changed.add(field)));
      if(!changed.size) {
        this.$store.dispatch('displaySnackbar', {
          text: this.$t('modal.bulkReplaceNothingToDo'), mode: 'error'
        });
        return;
      }

      const info = { idsource: this.selectedFA.doc_id };
      changed.forEach(field => {
        switch(field) {
          case "motor_img": info.img_motor = this.img_motor; break;
          case "gearbox_img": info.img_gearbox = this.img_gearbox; break;
          case "motor_doc": info.doc_motor = this.doc_motor; break;
          case "gearbox_doc": info.doc_gearbox = this.doc_gearbox; break;
          default: Object.assign(info, this.buildFieldPayload(field)); break;
        }
      });

      this.bulkReport = null;
      this.bulkTotal = selected.length;
      this.bulkProcessed = 0;
      this.bulkStopped = false;
      this.$modal.show('popupBulkProgress');
      try {
        const run = await this.runDuplicationChunks(info, selected.map(doc => doc.doc_id));
        this.applyBulkReport(selected, run);
      } catch(e) {
        this.reportBulk(0, selected.map(doc => String(doc.doc_id)));
      } finally {
        this.$modal.hide('popupBulkProgress');
        this.$modal.show('popupBulkReport');
      }
	  },
	  summariseRun(run) {
      const results = run.results || [];
      return {
        results,
        remainingIds: (run.remaining || []).map(id => String(id)),
        failedIds: results.filter(r => !r.ok).map(r => String(r.document_id)),
        untouchedIds: results
          .filter(r => r.ok && !(r.applied && r.applied.length))
          .map(r => String(r.document_id)),
        failures: results.filter(r => !r.ok).map(r => ({
          id: String(r.document_id),
          message: r.message || r.type || 'erreur inconnue'
        })),
        skippedByDoc: results
          .filter(r => (r.skippedAttachments || []).length)
          .map(r => ({ id: String(r.document_id), labels: r.skippedAttachments })),
        skipped: [ ...new Set(results.reduce((acc, r) => acc.concat(r.skippedAttachments || []), [])) ]
      };
	  },
	
	  applyBulkReport(selected, run) {
      const summary = this.summariseRun(run);

      if((run.problem === 'unexpected' || run.problem === 'nothing') && !summary.results.length) {
        this.reportBulk(0, [], run.problem, [], [], selected.map(doc => String(doc.doc_id)));
        return;
      }

      const byId = {};
      summary.results.forEach(r => { byId[String(r.document_id)] = r; });
      let updated = 0;

      selected.forEach(doc => {
        const result = byId[String(doc.doc_id)];
        if(!result || !result.ok) {
          return;
        }
        const written = this.appliedToFields(result.applied);
        if(!written.length) {
          return;
        }
        updated += 1;
        written.forEach(type => this.applyLocalChange(doc, type));
        this.$set(doc, 'selectedDuplication', false);
      });

      if(!summary.failedIds.length && !summary.untouchedIds.length && !summary.remainingIds.length) {
        this.allSelect = false;
      }

      this.reportBulk(updated, summary.failedIds, run.problem,
        summary.untouchedIds, summary.skipped, summary.remainingIds, summary);
      if(summary.skippedByDoc.length) {
        this.$store.dispatch('displaySnackbar', {
          text: `Pièces jointes non copiées sur ${summary.skippedByDoc.length} fiche(s) — détail dans le rapport`,
          mode: 'error'
        });
      }
	  },
	  reportBulk(succeeded, failedIds, problem, untouchedIds, skippedAttachments, remainingIds, summary) {
      this.bulkReport = {
        succeeded,
        failed: failedIds.length,
        failedIds,
        problem: problem || null,
        untouchedIds: untouchedIds || [],
        skippedAttachments: skippedAttachments || [],
        remainingIds: remainingIds || [],
        failures: (summary && summary.failures) || failedIds.map(id => ({ id, message: 'erreur inconnue' })),
        skippedByDoc: (summary && summary.skippedByDoc) || []
      };
	  },
      getCheckImgMotor() {
          var tmp = [];
        for(var i in this.img_motor) {
            if(this.img_motor[i].selected) {
                tmp.push(this.img_motor[i].label)
            }
        } 
        return tmp;
      },
      getCheckImgGearbox() {
          var tmp = [];
        for(var i in this.img_gearbox) {
            if(this.img_gearbox[i].selected) {
                tmp.push(this.img_gearbox[i].label)
            }
        } 
        return tmp;
      },
	  getCheckDocMotor() {
          var tmp = [];
        for(var i in this.doc_motor) {
            if(this.doc_motor[i].selected) {
                tmp.push(this.doc_motor[i].label)
            }
        } 
        return tmp;
      },
      getCheckDocGearbox() {
          var tmp = [];
        for(var i in this.doc_gearbox) {
            if(this.doc_gearbox[i].selected) {
                tmp.push(this.doc_gearbox[i].label)
            }
        } 
        return tmp;
      },
      checkCol(col) {
          var valide = true;
          if(col.key == "motor_type" && !this.motor_type_check) {
              valide = false;
            }
            if(col.key == "motor_adapt" && !this.motor_adapt_check) {
              valide = false;
            }
            if(col.key == "motor_observateur" && !this.motor_observation_check) {
              valide = false;
            }
			if(col.key == "motor_img" && !this.motor_img_check) {
              valide = false;
            }
			if(col.key == "motor_doc" && !this.motor_doc_check) {
              valide = false;
            }
            
             if(col.key == "gearbox_type" && !this.gearbox_type_check) {
              valide = false;
            }
            if(col.key == "gearbox_adapt" && !this.gearbox_adapt_check) {
              valide = false;
            }
            if(col.key == "gearbox_observateur" && !this.gearbox_observation_check) {
              valide = false;
            }
			if(col.key == "gearbox_img" && !this.gearbox_img_check) {
              valide = false;
            }
			if(col.key == "gearbox_doc" && !this.gearbox_doc_check) {
              valide = false;
            }
            return valide;
      },
      clickAllSelect(event) {
          event.stopPropagation();
            },
        clickFaExclue(event) {
          event.stopPropagation();
            },
      async selectFA(e) {
          
          
          this.gearbox_observation_check = true;
          this.gearbox_type_check = true;
          this.gearbox_adapt_check = true;
		  this.gearbox_img_check = true;
		  this.gearbox_doc_check = true;
          this.motor_observation_check = true;
          this.motor_type_check = true;
          this.motor_adapt_check = true;
          this.motor_img_check = true;
		  this.motor_doc_check = true;
          this.allSelect = false;
          if(this.modeSearch == 1) {
            this.handleResetFilter();
          }
          else {
             // this.handleResetFilter2();
          }
      
          const documentData = await this.$store.dispatch('getDocument', e.doc_id);
          
        
          if(this.modeSearch == 1) {
            this.state = 3;
          }
          else {
              this.state = 4;
          }
         
                 
          this.selectedFA = {};
            this.selectedFA.motor_type = e.motor_type;
            this.selectedFA.motor_adapt = e.motor_adapt;
            this.selectedFA.motor_observation = e.motor_observation;
            this.selectedFA.gearbox_type = e.gearbox_type;
            this.selectedFA.gearbox_adapt = e.gearbox_adapt;
            this.selectedFA.gearbox_observation = e.gearbox_observation;

            this.selectedFA.aaa_brand = e.aaa_brand;
            this.selectedFA.aaa_model = e.aaa_model;
            this.selectedFA.aaa_energy = e.aaa_energy;
            this.selectedFA.tecdoc_date_min = e.tecdoc_date_min;
            this.selectedFA.doc_id = e.doc_id;
            this.selectedFA.id = e.id;
            
            
            this.img_motor = documentData.Image_Motor;
			var labelImg = "";
            for(var i in this.img_motor) {
                this.img_motor[i].selected = true;
				if(labelImg != "") {
					labelImg+=", ";
				}
				labelImg += this.img_motor[i].label
            }
			this.selectedFA.motor_img = labelImg;
			
			
            
            this.img_gearbox = documentData.Image_Gearbox; 
			var labelImg2 = "";
            for(var i in this.img_gearbox) {
                this.img_gearbox[i].selected = true;
				if(labelImg2 != "") {
					labelImg2+=", ";
				}
				labelImg2 += this.img_gearbox[i].label
            }
			
			this.selectedFA.gearbox_img = labelImg2;
			
			
			this.doc_motor = documentData.Document_Motor;
			var labelDoc = "";
            for(var i in this.doc_motor) {
                this.doc_motor[i].selected = true;
				if(labelDoc != "") {
					labelDoc+=", ";
				}
				labelDoc += this.doc_motor[i].label
            }
			this.selectedFA.motor_doc = labelDoc;
			
			
            
            this.doc_gearbox = documentData.Document_Gearbox; 
			var labeldoc2 = "";
            for(var i in this.doc_gearbox) {
                this.doc_gearbox[i].selected = true;
				if(labeldoc2 != "") {
					labeldoc2+=", ";
				}
				labeldoc2 += this.doc_gearbox[i].label
            }
			
			this.selectedFA.gearbox_doc = labeldoc2;
          
          
		  var cptColonne = 0;
		  if(this.modeSearch == 2) {
			  if(this.searchData.document_type2 == 1) {
				  this.gearbox_type_check = false;
				  this.gearbox_adapt_check = false;
				  this.gearbox_observation_check = false;
				  this.gearbox_img_check = false;
				  this.gearbox_doc_check = false;
				  if(this.motor_type_check) {
					  cptColonne++;
				  }
				  if(this.motor_adapt_check) {
					  cptColonne++;
				  }
				  if(this.motor_observation_check) {
					  cptColonne++;
				  }
				  if(this.motor_img_check) {
					  cptColonne++;
				  }
				  if(this.motor_doc_check) {
					  cptColonne++;
				  }
			  }
			  else {
				  this.motor_type_check = false;
				  this.motor_adapt_check = false;
				  this.motor_observation_check = false;
				  this.motor_img_check = false;
				  this.motor_doc_check = false;
				  if(this.gearbox_type_check) {
					  cptColonne++;
				  }
				  if(this.gearbox_adapt_check) {
					  cptColonne++;
				  }
				  if(this.gearbox_observation_check) {
					  cptColonne++;
				  }
				  if(this.gearbox_img_check) {
					  cptColonne++;
				  }
				  if(this.gearbox_doc_check) {
					  cptColonne++;
				  }
			  }
		  }

		  if(this.modeSearch == 1) {
			  if(this.searchData.document_type == 1) {
				  this.gearbox_type_check = false;
				  this.gearbox_adapt_check = false;
				  this.gearbox_observation_check = false;
				  this.gearbox_img_check = false;
				  this.gearbox_doc_check = false;
			  } else if(this.searchData.document_type == 2) {
				  this.motor_type_check = false;
				  this.motor_adapt_check = false;
				  this.motor_observation_check = false;
				  this.motor_img_check = false;
				  this.motor_doc_check = false;
			  }
		  }

		  this.$nextTick(() => {
		  const motorTS = this.$refs.motorTS;
		  const motorAS = this.$refs.motorAS;
		  const motorOS = this.$refs.motorOS;
		  const gearboxTS = this.$refs.gearboxTS;
		  const gearboxAS = this.$refs.gearboxAS;
		  const gearboxOS = this.$refs.gearboxOS;
		  const motorIS = this.$refs.motorIS;
		  const gearboxIS = this.$refs.gearboxIS;
		  
		  const motorDOCIS = this.$refs.motorDOCIS;
		  const gearboxDOCIS = this.$refs.gearboxDOCIS;
		  

		  
		  var largeurColonne = [];
		  
		  var largeurmotorTS = 0;
		  var largeurmotorAS = 0;
		  var largeurmotorOS = 0;
		  var largeurgearboxTS = 0;
		  var largeurgearboxAS = 0;
		  var largeurgearboxOS = 0;
		  var largeurmotorIS = 0;
		  var largeurgearboxIS = 0;
		  var largeurmotorDOCIS = 0;
		  var largeurgearboxDOCIS = 0;
		  
		  var cptnbC = 0;
		  if(motorTS != null) {
			largeurColonne.push(motorTS.offsetWidth);
		  }
		  if(motorAS != null) {
		  largeurColonne.push(motorAS.offsetWidth);
		  }
		  if(motorOS != null) {
		  largeurColonne.push(motorOS.offsetWidth);
		  }
		  if(gearboxTS != null) {
		  largeurColonne.push(gearboxTS.offsetWidth);
		  }
		  if(gearboxAS != null) {
		  largeurColonne.push(gearboxAS.offsetWidth);
		  }
		  if(gearboxOS != null) {
		  largeurColonne.push(gearboxOS.offsetWidth);
		  }
		  if(motorIS != null) {
		  largeurColonne.push(motorIS.offsetWidth);
		  }
		  if(gearboxIS != null) {
		  largeurColonne.push(gearboxIS.offsetWidth);
		  }
		  if(motorDOCIS != null) {
		  largeurColonne.push(motorDOCIS.offsetWidth);
		  }
		  if(gearboxDOCIS != null) {
		  largeurColonne.push(gearboxDOCIS.offsetWidth);
		  }
		  
		  console.log("largeurColonne : ");
		  console.log(largeurColonne);
		  

		  
		  switch(largeurColonne.length) {
			case 1:
			this.styleColonne1 = "position:relative;width:"+largeurColonne[0]+"px;";
			this.styleColonne2 = "position:relative;width:150px;";
			this.styleColonne3 = "position:relative;width:0px;";
			this.styleColonne4 = "position:relative;width:0px;";
			this.styleColonne5 = "position:relative;width:0px;";
			this.styleColonne6 = "position:relative;width:0px;";
			this.styleColonne7 = "position:relative;width:0px;";
			this.styleColonne8 = "position:relative;width:0px;";
			this.styleColonne9 = "position:relative;width:0px;";
			break;
			case 2:
			this.styleColonne1 = "position:relative;width:"+largeurColonne[0]+"px;";
			this.styleColonne2 = "position:relative;width:"+largeurColonne[1]+"px;";
			this.styleColonne3 = "position:relative;width:150px;";
			this.styleColonne4 = "position:relative;width:0px;";
			this.styleColonne5 = "position:relative;width:0px;";
			this.styleColonne6 = "position:relative;width:0px;";
			this.styleColonne7 = "position:relative;width:0px;";
			this.styleColonne8 = "position:relative;width:0px;";
			this.styleColonne9 = "position:relative;width:0px;";
			break;
			case 3:
			this.styleColonne1 = "position:relative;width:"+largeurColonne[0]+"px;";
			this.styleColonne2 = "position:relative;width:"+largeurColonne[1]+"px;";
			this.styleColonne3 = "position:relative;width:"+largeurColonne[2]+"px;";
			this.styleColonne4 = "position:relative;width:150px;";
			this.styleColonne5 = "position:relative;width:0px;";
			this.styleColonne6 = "position:relative;width:0px;";
			this.styleColonne7 = "position:relative;width:0px;";
			this.styleColonne8 = "position:relative;width:0px;";
			this.styleColonne9 = "position:relative;width:0px;";
			break;
			case 4:
			this.styleColonne1 = "position:relative;width:"+largeurColonne[0]+"px;";
			this.styleColonne2 = "position:relative;width:"+largeurColonne[1]+"px;";
			this.styleColonne3 = "position:relative;width:"+largeurColonne[2]+"px;";
			this.styleColonne4 = "position:relative;width:"+largeurColonne[3]+"px;";
			this.styleColonne5 = "position:relative;width:150px;";
			this.styleColonne6 = "position:relative;width:0px;";
			this.styleColonne7 = "position:relative;width:0px;";
			this.styleColonne8 = "position:relative;width:0px;";
			this.styleColonne9 = "position:relative;width:0px;";
			break;
			case 5:
			this.styleColonne1 = "position:relative;width:"+largeurColonne[0]+"px;";
			this.styleColonne2 = "position:relative;width:"+largeurColonne[1]+"px;";
			this.styleColonne3 = "position:relative;width:"+largeurColonne[2]+"px;";
			this.styleColonne4 = "position:relative;width:"+largeurColonne[3]+"px;";
			this.styleColonne5 = "position:relative;width:"+largeurColonne[4]+"px;";
			this.styleColonne6 = "position:relative;width:150px;";
			this.styleColonne7 = "position:relative;width:0px;";
			this.styleColonne8 = "position:relative;width:0px;";
			this.styleColonne9 = "position:relative;width:0px;";
			break;
			case 6:
			this.styleColonne1 = "position:relative;width:"+largeurColonne[0]+"px;";
			this.styleColonne2 = "position:relative;width:"+largeurColonne[1]+"px;";
			this.styleColonne3 = "position:relative;width:"+largeurColonne[2]+"px;";
			this.styleColonne4 = "position:relative;width:"+largeurColonne[3]+"px;";
			this.styleColonne5 = "position:relative;width:"+largeurColonne[4]+"px;";
			this.styleColonne6 = "position:relative;width:"+largeurColonne[5]+"px;";
			this.styleColonne7 = "position:relative;width:150px;";
			this.styleColonne8 = "position:relative;width:0px;";
			this.styleColonne9 = "position:relative;width:0px;";
			break;
			
		  }
		 
		  
		
		  });
	
		  
		  this.generationtailleColonne(cptColonne);
          this.cols.forEach(col => { col.sorted = ''; });
          this.nextAction(true);
      },
      cancelAction() {
          this.state = 1;
          this.handleResetFilter();
      },
      previousActionStep2() {
          this.state = 1;
      },
     saveModalName() {
       return this.state == '4' ? 'popupSaveGrid' : 'popupSaveBulk';
     },
     showModal() {
         var valide = false;
        for(var i in this.documentsSelected) {
         if(this.documentsSelected[i].selectedDuplication) {
             valide = true;
             break;
         }
        }
        if(valide) {
            this.$modal.show(this.saveModalName());
        }
    },
    closeModal() {
      this.$modal.hide(this.saveModalName());
    },
    showReplaceAllModal() {
      const hasSelection = this.documentsSelected.some(d => d.selectedDuplication);
      if (hasSelection) {
        this.$modal.show('popupReplaceAllSelected');
      }
    },
    async confirmReplaceAllSelected() {
      this.$modal.hide('popupReplaceAllSelected');
      await this.updateAllDataDocumentSelected();
    },
      async saveDuplication() {
        if(this.duplicationSend) {
          return;
        }

        var info = {};
        var valideProperty = false;
        if(this.motor_type_check) {
            valideProperty = true;
          info.motor_type = this.selectedFA.motor_type ? this.selectedFA.motor_type.split(',').map(e => e.trim()) : [];
        }
        if(this.motor_adapt_check) {
             valideProperty = true;
          info.motor_adaptability = this.selectedFA.motor_adapt ? this.selectedFA.motor_adapt.split(',').map(e => e.trim()) : [];
        }
        if(this.motor_observation_check) {
           valideProperty = true;
          info.motor_observation = typeof this.selectedFA.motor_observation === 'undefined'
            ? null : this.selectedFA.motor_observation;
        }
        if(this.gearbox_type_check) {
           valideProperty = true;
          info.gearbox_type = this.selectedFA.gearbox_type ? this.selectedFA.gearbox_type.split(',').map(e => e.trim()) : [];
        }
        if(this.gearbox_adapt_check) {
           valideProperty = true;
          info.gearbox_adaptability = this.selectedFA.gearbox_adapt ? this.selectedFA.gearbox_adapt.split(',').map(e => e.trim()) : [];
        }
        if(this.gearbox_observation_check) {
           valideProperty = true;
          info.gearbox_observation = typeof this.selectedFA.gearbox_observation === 'undefined'
            ? null : this.selectedFA.gearbox_observation;
        }

        var listDocumentUpdate = [];
        for(var i in this.documentsSelected) {
         if(this.documentsSelected[i].selectedDuplication) {
             listDocumentUpdate.push(this.documentsSelected[i].doc_id);
         }
        }
        info.idsource = this.selectedFA.doc_id;
        info.img_motor = this.img_motor;
        info.img_gearbox = this.img_gearbox;
        info.doc_motor = this.doc_motor;
        info.doc_gearbox = this.doc_gearbox;

        var attachments = [].concat(this.img_motor || [], this.img_gearbox || [],
          this.doc_motor || [], this.doc_gearbox || []);
        if(attachments.some(e => e && e.selected)) {
          valideProperty = true;
        }

        if(!listDocumentUpdate.length || !valideProperty) {
          this.$store.dispatch('displaySnackbar', {
            text: 'Sélectionnez au moins une fiche article et une donnée à dupliquer',
            mode: 'error'
          });
          return;
        }

        this.duplicationSend = true;
        this.bulkReport = null;
        this.bulkTotal = listDocumentUpdate.length;
        this.bulkProcessed = 0;
        this.bulkStopped = false;
        this.closeModal();
        this.$modal.show('popupBulkProgress');
        try {
          const run = await this.runDuplicationChunks(info, listDocumentUpdate);
          const summary = this.summariseRun(run);
          if((run.problem === 'unexpected' || run.problem === 'nothing') && !summary.results.length) {
            this.reportBulk(0, [], run.problem, [], [], listDocumentUpdate.map(id => String(id)));
          } else {
            const updated = summary.results.filter(r => r.ok && r.applied && r.applied.length);
            this.reportBulk(updated.length, summary.failedIds, run.problem,
              summary.untouchedIds, summary.skipped, summary.remainingIds, summary);
          }
          this.allSelect = false;
          this.nextAction();
        } catch(e) {
          this.reportBulk(0, listDocumentUpdate.map(id => String(id)));
        } finally {
          this.duplicationSend = false;
          this.$modal.hide('popupBulkProgress');
          this.$modal.show('popupBulkReport');
        }
      },
      previousAction() {
          this.handleResetFilter();
          this.state = 1;
          
      },
      async nextAction(resetSort = false) {
          this.$store.dispatch('setLoading', true);
          
		  var tmpParam = {
			  page: 1,
			  limit: Number(1000),
			  brand: this.searchData.brand,
			  cnit: this.searchData.cnit,
			  cnit_mine_condition: this.searchData.cnit_mine_status,
			  document_id: this.searchData.document_id,
			  document_type_id: this.searchData.document_type,
			  energy: this.searchData.energy,
			  gearbox_type: this.searchData.gearbox_type,
			  ktype: this.searchData.ktype,
			  motor_type: this.searchData.motor_type,
			  status_document_id: this.searchData.status_document,
			  id_ignore:this.selectedFA.doc_id,
        // faExclue: false,
			  version: this.searchData.version,
			  orderBy: resetSort ? [ 'Document.updatedAt|DESC' ] : (this.$route.query.orderBy ? Array.isArray(this.$route.query.orderBy) ? this.$route.query.orderBy : [ this.$route.query.orderBy ] : [ 'Document.updatedAt|DESC' ])
			}
			var data = [];
		  this.allSelect = false;
          this.documentsSelected = [];
		  if(this.modeSearch == 2) {
			  

			  tmpParam.document_type_id= this.searchData.document_type2,
			  tmpParam.type = this.selectedFA.motor_type;
			  tmpParam.infoSource = this.selectedFA;
			  if(this.searchData.document_type2 == 2) {
				  tmpParam.type = this.selectedFA.gearbox_type;
			  }
			  tmpParam.faExclue = this.faExclue;
			  data = await this.$store.dispatch('getDocumentsByType', tmpParam);
		  }
		  else {

			data = await this.$store.dispatch('getDocuments', tmpParam);
          }
        if (data.length) {
			if(data[0].counter != null) {
				this.documentsCount = data[0].counter;
				
			}
			else {
				this.documentsCount =data.length;
			}
        } else {
          this.documentsCount = 0;
        }
        this.documentsSelected = data;

      },
  
    handleResetFilter() {
      this.brand = '';
      this.cnit = '';
      this.cnit_mine_status = '';
      this.document_id = '';
      this.document_type = '';
      this.energy = '';
      this.gearbox_type = '';
      this.ktype = '';
      this.motor_type = '';
      this.status_document = '';
      this.version = '';
      this.searchData['brand'] = this.brand;
      this.searchData['cnit'] = this.cnit;
      this.searchData['cnit_mine_status'] = this.cnit_mine_status;
      this.searchData['document_id'] = this.document_id;
      this.searchData['document_type'] = this.document_type;
      this.searchData['energy'] = this.energy;
      this.searchData['gearbox_type'] = this.gearbox_type;
      this.searchData['ktype'] = this.ktype;
      this.searchData['motor_type'] = this.motor_type;
      this.searchData['status_document'] = this.status_document;
      this.searchData['version'] = this.version;
      // FIXME : reset search object
    },
    
     handleResetFilter2() {

      this.deleteMarque();
      this.brand2 = '';
      this.document_type2 = '';
      this.motor_gearbox_type2 = '';
      this.document_id2 = '';
      this.searchData['brand2'] = this.brand2;
      this.searchData['document_type2'] = this.document_type2;
      this.searchData['motor_gearbox_type2'] = this.motor_gearbox_type2;
      this.searchData['document_id2'] = this.document_id2;
      // FIXME : reset search object
    },
    
    async handleFilterResults() {
      
      this.searchData['brand'] = this.brand;
      this.searchData['cnit'] = this.cnit;
      this.searchData['cnit_mine_status'] = this.cnit_mine_status;
      this.searchData['document_id'] = this.document_id;
      this.searchData['document_type'] = this.document_type;
      this.searchData['energy'] = this.energy;
      this.searchData['gearbox_type'] = this.gearbox_type;
      this.searchData['ktype'] = this.ktype;
      this.searchData['motor_type'] = this.motor_type;
      this.searchData['status_document'] = this.status_document;
      this.searchData['version'] = this.version;
	  this.modeSearch = 1;
      this.filterOnGoing = true;
      await this.getData(true, false);
      this.filterOnGoing = false;
    },
    async handleFilterResults2() {

      this.searchData['brand2'] = this.brand2;
      this.searchData['document_type2'] = this.document_type2;
      this.searchData['motor_gearbox_type2'] = this.motor_gearbox_type2;
      this.searchData['document_id2'] = this.document_id2;
      this.modeSearch = 2;
      this.filterOnGoing = true;
      await this.getData(true, false);
      
      this.filterOnGoing = false;
    },
    async handleFilterResultsDuplication() {
  
        this.allSelect = false;
        this.$store.dispatch('setLoading', true);
      this.searchData['brand'] = this.brand;
      this.searchData['cnit'] = this.cnit;
      this.searchData['cnit_mine_status'] = this.cnit_mine_status;
      this.searchData['document_id'] = this.document_id;
      this.searchData['document_type'] = this.document_type;
      this.searchData['energy'] = this.energy;
      this.searchData['gearbox_type'] = this.gearbox_type;
      this.searchData['ktype'] = this.ktype;
      this.searchData['motor_type'] = this.motor_type;
      this.searchData['status_document'] = this.status_document;
      this.searchData['version'] = this.version;

      this.filterOnGoing = true;
      
      var ignore = null;
      if(this.selectedFA.doc_id != null) {
          ignore = this.selectedFA.doc_id;
      }
      
     // await this.getData(true, false);
      const data = await this.$store.dispatch('getDocuments', {
          page: 1,
          limit: Number(1000),
          brand: this.searchData.brand,
          cnit: this.searchData.cnit,
          cnit_mine_condition: this.searchData.cnit_mine_status,
          document_id: this.searchData.document_id,
          document_type_id: this.searchData.document_type,
          energy: this.searchData.energy,
          gearbox_type: this.searchData.gearbox_type,
          ktype: this.searchData.ktype,
          motor_type: this.searchData.motor_type,
          status_document_id: this.searchData.status_document,
          id_ignore:ignore,
          faExclue: false,
          version: this.searchData.version,
          orderBy: this.$route.query.orderBy ? Array.isArray(this.$route.query.orderBy) ? this.$route.query.orderBy : [ this.$route.query.orderBy ] : [ 'Document.updatedAt|DESC' ]
        });
        if (data.length) {
          this.documentsCount = data[0].counter;
        } else {
          this.documentsCount = 0;
        }
       
        this.documentsSelected = data;
      this.filterOnGoing = false;
    },
    /* -- Table actions -- */
    /* Returns ba-state-label color depending on its value */
    getStatusColor(status) {
      if (status == 'Validé') return 'success';
      return 'pending';
    },
    /* Image for error case */
    defaultImage(e) {
      e.target.src = 'https://cdn.activcar.fr/media/64/brands/default.png';
    },
    /* Get document motors & gearboxes */
    getTypeAdaptability(adap) {
      // const typeArray = (type && type.length) ? type.split(',') : [];
      const adapArray = (adap && adap.length) ? adap.split(',') : [];
      // const text = adapArray.length ? typeArray.concat(adapArray) : typeArray;
      return adapArray;
    },
    /* Get brand image */
    handleGetBrandImage(brand) {
      let text = brand.split(/[ -]+/)[0].toLowerCase();
      if (text == 'citroën') { text = 'citroen'; }
      if (text == 'vw') { text = 'volkswagen'; }
      if (text == 'land') { text = 'rover'; }
      if (text == 'bedford') { text = 'vauxhall'; }
      return `https://cdn.activcar.fr/media/64/brands/${text}.png`;
    },
    async handleUpdateDocumentStatus(id, status) {
   
      if (id) {
        const data = await this.$store.dispatch('updateDocument', {
          id: id,
          status_document_id: status
        });
        if (data && data.id) {
          if (status == 1) this.$store.dispatch('displaySnackbar', { text: "La fiche article est validée", mode: '' });
          if (status == 2) this.$store.dispatch('displaySnackbar', { text: "La fiche article n'est plus validée", mode: '' });
          // Reload data list depending on search with filters or with matriculation
          this.getData(true, this.matriculationSearch ? true : false);
        } else {
          this.$store.dispatch('displaySnackbar', { text: "Une erreur est survenue. Veuillez réessayer", mode: 'error' });
        }
      }
    },
    async handleRemoveDocument() {
     
      if (this.documentId !== false) {
        const data = await this.$store.dispatch('deleteDocument', {
          id: this.documentId,
          page: this.currentPage,
          limit: Number(this.$store.getters.getLimit)
        });
        if (data) {
          this.$store.dispatch('displaySnackbar', { text: "La fiche article a été supprimée", mode: '' });
        }
        // Reload list of documents & keep filter active
        await this.getData(false, this.matriculationSearch ? true : false);
        this.closeModal();
      }
    },
	deleteMarque() {
                this.selectedBrand = null;
                this.listFilterBrand = [];
                this.brand2 = "";
              

            },
	 selectBrand(item) {
                this.selectedBrand = item;
                this.brand2 = item.name;
                this.listFilterBrand = [];
            },
	handleSearchMarque() {
                var tmpSearch = this.brand2;
                var tmpMarque = this.infoBrand;
                if (tmpSearch.length >= 1) {
                    this.listFilterBrand = tmpMarque.filter((item) =>
                        item.name.toLowerCase().includes(tmpSearch.toLowerCase()));
                } else {
                    this.listFilterBrand = [];
                }

            },

    /* -- Paginate mixin -- */
    async getData(isNewSearch, isMatriculationSearch) {
       
		if(this.modeSearch == 1) {
		  this.currentPage = isNewSearch ? 1 : this.currentPage;

		  // Search from matriculation or with filters
		  this.$store.dispatch('setLoading', true);
		  if (isMatriculationSearch) {
			if (this.matriculationSearch) {
			  const data = await this.$store.dispatch('getVehicleByMatriculation', this.matriculationSearch);
			  if (data && data.Aaa.ktype) {
				const associatedDocuments = await this.$store.dispatch('getDocumentsByKtype', {
				  ktype: data.Aaa.ktype,
				  motor_type: data.Aaa.motor_type,
				  gearbox: data.Aaa.gearbox,
				  vehicle_cnit: data.Aaa.cnit,
				  vehicle_mine: data.Aaa.mine,
				  page: 1,
				  limit: Number(this.$store.getters.getLimit)
				});
				if (associatedDocuments && associatedDocuments.length) {
				  this.documentsCount = associatedDocuments[0].counter;
				}
			  }
			} else {
			  this.$store.dispatch('displaySnackbar', { text: "Veuillez entrer une immatriculation", mode: 'error' });
			}
		  } else {
			const data = await this.$store.dispatch('getDocuments', {
			  page: this.currentPage,
			  limit: Number(this.$store.getters.getLimit),
			  brand: this.searchData.brand,
			  cnit: this.searchData.cnit,
			  cnit_mine_condition: this.searchData.cnit_mine_status,
			  document_id: this.searchData.document_id,
			  document_type_id: this.searchData.document_type,
			  energy: this.searchData.energy,
			  gearbox_type: this.searchData.gearbox_type,
			  ktype: this.searchData.ktype,
			  motor_type: this.searchData.motor_type,
			  status_document_id: this.searchData.status_document,
			  version: this.searchData.version,
			  orderBy: this.$route.query.orderBy ? Array.isArray(this.$route.query.orderBy) ? this.$route.query.orderBy : [ this.$route.query.orderBy ] : [ 'Document.updatedAt|DESC' ]
			});
			if (data.length) {
			  this.documentsCount = data[0].counter;
			} else {
			  this.documentsCount = 0;
			}
			
			this.documents = data;
		  }
		  this.$store.commit('setSpinner', false);
		  this.$store.dispatch('setLoading', false);
		}
		else if(this.modeSearch == 2) {
			 this.currentPage = isNewSearch ? 1 : this.currentPage;

      // Search from matriculation or with filters
      this.$store.dispatch('setLoading', true);
      if (isMatriculationSearch) {
        if (this.matriculationSearch) {
          const data = await this.$store.dispatch('getVehicleByMatriculation', this.matriculationSearch);
          if (data && data.Aaa.ktype) {
            const associatedDocuments = await this.$store.dispatch('getDocumentsByKtype', {
              ktype: data.Aaa.ktype,
              motor_type: data.Aaa.motor_type,
              gearbox: data.Aaa.gearbox,
              vehicle_cnit: data.Aaa.cnit,
              vehicle_mine: data.Aaa.mine,
              page: 1,
              limit: Number(this.$store.getters.getLimit)
            });
            if (associatedDocuments && associatedDocuments.length) {
              this.documentsCount = associatedDocuments[0].counter;
            }
          }
        } else {
          this.$store.dispatch('displaySnackbar', { text: "Veuillez entrer une immatriculation", mode: 'error' });
        }
      } else {

        const data = await this.$store.dispatch('getDocuments2', {
          page: this.currentPage,
          limit: Number(this.$store.getters.getLimit),
          brand2: this.searchData.brand2,
		  faExclue:this.faExclue,
          document_type_id2: this.searchData.document_type2,
          type2: this.searchData.motor_gearbox_type2,
          document_id2: this.searchData.document_id2,
          orderBy: this.$route.query.orderBy ? Array.isArray(this.$route.query.orderBy) ? this.$route.query.orderBy : [ this.$route.query.orderBy ] : [ 'Document.updatedAt|DESC' ]
        });
        if (data.length) {
          this.documentsCount = data[0].counter;
        } else {
          this.documentsCount = 0;
        }

        this.documents = data;
      }
      this.$store.commit('setSpinner', false);
      this.$store.dispatch('setLoading', false);
		}
    },
    async getData2(isNewSearch, isMatriculationSearch) {

      this.currentPage = isNewSearch ? 1 : this.currentPage;

      // Search from matriculation or with filters
      this.$store.dispatch('setLoading', true);
      if (isMatriculationSearch) {
        if (this.matriculationSearch) {
          const data = await this.$store.dispatch('getVehicleByMatriculation', this.matriculationSearch);
          if (data && data.Aaa.ktype) {
            const associatedDocuments = await this.$store.dispatch('getDocumentsByKtype', {
              ktype: data.Aaa.ktype,
              motor_type: data.Aaa.motor_type,
              gearbox: data.Aaa.gearbox,
              vehicle_cnit: data.Aaa.cnit,
              vehicle_mine: data.Aaa.mine,
              page: 1,
              limit: Number(this.$store.getters.getLimit)
            });
            if (associatedDocuments && associatedDocuments.length) {
              this.documentsCount = associatedDocuments[0].counter;
            }
          }
        } else {
          this.$store.dispatch('displaySnackbar', { text: "Veuillez entrer une immatriculation", mode: 'error' });
        }
      } else {
        const data = await this.$store.dispatch('getDocuments2', {
          page: this.currentPage,
          limit: Number(this.$store.getters.getLimit),
          brand2: this.searchData.brand2,
          faExclue: this.faExclue,
          document_type_id2: this.searchData.document_type2,
          type2: this.searchData.motor_gearbox_type2,
          document_id2: this.searchData.document_id2,
          orderBy: this.$route.query.orderBy ? Array.isArray(this.$route.query.orderBy) ? this.$route.query.orderBy : [ this.$route.query.orderBy ] : [ 'Document.updatedAt|DESC' ]
        });
        if (data.length) {
          this.documentsCount = data[0].counter;
        } else {
          this.documentsCount = 0;
        }

        this.documents = data;
      }
      this.$store.commit('setSpinner', false);
      this.$store.dispatch('setLoading', false);
    },
  },
  watch: {
      ...generateSearchWatcher([
    'brand',
    'brand2',
    'cnit',
    'cnit_mine_status',
    'document_id',
    'document_type',
    'document_type2',
    'motor_gearbox_type2',
    'energy',
    'gearbox_type',
    'ktype',
    'motor_type',
    'status_document',
    'version'
  ]),
    allSelect() {
            for(var i in this.documentsSelected) {
                this.$set(this.documentsSelected[i], 'selectedDuplication', this.allSelect);
            }
        
    }
}
};
</script>

<style scoped>
    
    .btSelect {
        background-color: var(--ba-button-bg-primary, rgb(50, 115, 220));
        color: var(--ba-button-color-primary, rgb(255, 255, 255));
    }
    
.blockInfo {
    background-color: var(--app-light-blue, #e1eeff);
    box-shadow: var(--ba-card-box-shadow, 0 1px 4px rgba(0, 0, 0, 0.25));
    color: var(--basic-white-color, #FFFFFF);
    border-radius:8px;
    font-style: normal;
    padding:5px 5px 5px 15px;
    font-weight: 500;
    font-size: 1.2rem;
    line-height: 1.5rem;
    max-width:676px;
    margin: 0.5rem 0 0 0;
    position:relative;
    display: flex;
    justify-content: space-between;
    position:relative;
    width:676px;
}

.blockInfo hr {
  color: #688CB8;
  height: 1px;
  position:absolute;
  top: 2rem;
  left: 51%;
  transform: translate(-50%, -50%);
  width: 66%;
}

.blockInfo figure{
  max-width:110px;
  position:relative;
  text-align: center;
  z-index:10;
}

.blockInfo figure .StepNumber {
  background-color: var(--app-white-color, #FFFFFF);
  border-radius: 50%;
  color: var(--app-primary-color, rgb(135, 138, 146));
  height:1.9375rem;
  line-height: 27px;
  margin: 0 auto 0.75rem auto;
  text-align:center;
  width:1.9375rem;
}

.blockInfo figure.active .StepNumber {
  background-color: var(--ba-state-success-bg-color, rgb(155, 247, 151));
  color: var(--app-white-color, #FFFFFF);
}

.blockInfo figure figcaption {
  color: var(--app-lightgrey-color, rgb(243, 243, 243));
  font-size: 0.8125rem;
  line-height: 1.3rem;
  font-weight: bold;
}

.blockInfo figure.active figcaption {
  color: var(--app-primary-color, rgb(135, 138, 146));
}
    
/* Margin between searchcard, button & table */
.document-list .ba-search-card { margin-top: 1rem; }
.document-button { margin-top: 2rem; }
.document-list .ba-table { margin-top: 0.5rem; }

/* Form */
.document-list .matriculation-form {
  width: 50%;
  max-width: 10rem;
}

/* Table style */
.document-button div { font-weight: 500; }

.document-list img { width: 64px; }

/* Speedometer */
.document-list .speedometer {
  text-align: center;
  margin-top: 0.25rem;
}
.limiteObservation {
    max-width:450px;
    white-space: pre-line;
}
.limiteObservation > div,
.limiteObservation > li {
    overflow-wrap: break-word;
}

.texteAreaFA {
    height:200px;
}

/* ICONS */
.next,
.prev,
.start,
.validate {
  color: var(--app-lightgrey-color, rgb(135, 138, 146));
  height: 2.5rem;
  width: 2.5rem;
}

.divValidate {
  right: 1rem;
  bottom: 0;
}

.divPrev,
.divPrev2,
.divValidate,
.divStart {
  position: absolute;
}

.divPrev {
  left: -80px;
  top: 50%;
  transform: translate(0, -50%);
}

.divStart {
  left: -130px;
  top: 50%;
  transform: translate(0, -50%);
}

.divPrev2 {
  right: -80px;
  bottom: 50%;
  transform: translate(0, 50%);
}

.divEmpty {
  height:100px;
  width:190px;
}

.no-button {
  box-shadow: none;
}

.no-button,
.no-button:hover {
  background: none;
}

.w-full {
  width: 100%;
}

.justify-center {
  justify-content:center;
}

.relative {
  position:relative;
}

/* CHECKBOX */
.ba-checkbox .checkbox-label > span {
  margin-right: 0;
}

/* TABLE */
.col-separator th,
.col-separator td {
  border-right: 1px solid #e6e6e6;
}

.border-table {
  border: 2px solid var(--app-primary-color);
  border-radius: 10px;
  margin-top: 0.5rem;
}

.document-list .border-table .ba-table {
  margin-top: 0;
}

/* Margin top pagination */
.mt12 {
    margin-top: 0.79rem;
}

.dropdown-part {
        background-color:var(--app-input-dropdown-bg-color, rgb(255, 255, 255));
        position:absolute;
        z-index:10;
        box-shadow:var(--ba-input-box-shadow, 0 1px 1px rgba(0,0,0,0.2));
        border-radius:0 0 5px 5px;

    }

    .dropdown-part-u {
        list-style: none;
        font-size: 1rem;
        margin:0;
        padding:1rem 0;
        width:100%;
        max-height:20rem;
        overflow-y:auto;
    }

    .dropdown-part-li {
        display:block;
        color:var(--ba-input-dropdown-element-color, rgb(92, 92, 92));
        font-weight:normal;
        padding-left:10px;
        cursor:pointer;
    }

    .dropdown-part-li:hover {
        background-color:rgb(92, 92, 92);
        color:white;
    }
	
	.colonneEmptyEnd{
		position: relative; 
		width: 150px;
	}
	.colonneLogo{
		position: relative; 
		width: 110px;
	}
	.colonneVehicule{
		position: relative; 
		width: 190px;
	}
	
</style>
<style src="@/assets/styles/modals.css"></style>
<style src="@/assets/styles/paginations.css"></style>
<style src="@/assets/styles/documents.css"></style>
